function _defineProperty(a, b, c) {
    return b in a ? Object.defineProperty(a, b, { value: c, enumerable: !0, configurable: !0, writable: !0 }) : (a[b] = c), a;
}
function _get(a, b, c) {
    return (_get =
        "undefined" != typeof Reflect && Reflect.get
            ? Reflect.get
            : function (d, b, e) {
                  var c = _superPropBase(d, b);
                  if (c) {
                      var a = Object.getOwnPropertyDescriptor(c, b);
                      return a.get ? a.get.call(e) : a.value;
                  }
              })(a, b, c || a);
}
function _superPropBase(a, b) {
    for (; !Object.prototype.hasOwnProperty.call(a, b) && null !== (a = _getPrototypeOf(a)); );
    return a;
}
function _inherits(b, a) {
    if ("function" != typeof a && null !== a) throw new TypeError("Super expression must either be null or a function");
    (b.prototype = Object.create(a && a.prototype, { constructor: { value: b, writable: !0, configurable: !0 } })), a && _setPrototypeOf(b, a);
}
function _setPrototypeOf(a, b) {
    return (_setPrototypeOf =
        Object.setPrototypeOf ||
        function (a, b) {
            return (a.__proto__ = b), a;
        })(a, b);
}
function _createSuper(a) {
    var b = _isNativeReflectConstruct();
    return function () {
        var c,
            d = _getPrototypeOf(a);
        if (b) {
            var e = _getPrototypeOf(this).constructor;
            c = Reflect.construct(d, arguments, e);
        } else c = d.apply(this, arguments);
        return _possibleConstructorReturn(this, c);
    };
}
function _possibleConstructorReturn(b, a) {
    return a && ("object" === _typeof(a) || "function" == typeof a) ? a : _assertThisInitialized(b);
}
function _assertThisInitialized(a) {
    if (void 0 === a) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return a;
}
function _isNativeReflectConstruct() {
    if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (a) {
        return !1;
    }
}
function _getPrototypeOf(a) {
    return (_getPrototypeOf = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (a) {
              return a.__proto__ || Object.getPrototypeOf(a);
          })(a);
}
function _typeof(a) {
    return (_typeof =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (a) {
                  return typeof a;
              }
            : function (a) {
                  return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
              })(a);
}
function _classCallCheck(a, b) {
    if (!(a instanceof b)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(d, c) {
    for (var b = 0; b < c.length; b++) {
        var a = c[b];
        (a.enumerable = a.enumerable || !1), (a.configurable = !0), "value" in a && (a.writable = !0), Object.defineProperty(d, a.key, a);
    }
}
function _createClass(a, b, c) {
    return b && _defineProperties(a.prototype, b), c && _defineProperties(a, c), a;
}
function headerSize() {
    var a = jQuery("div#sticky_header").outerHeight();
    jQuery("#PageContainer").css("padding-top", a);
}
window.matchMedia("(max-width: 767px)").matches &&
    jQuery(document).ready(function () {
       jQuery(".owl-carousel").owlCarousel({
                items: 1,
                loop: !0,
                dots: !1,
                margin: 10,
                nav: !0,
                navText: ['<img src="https://cdn.shopify.com/s/files/1/0197/2473/0432/files/long-arrow-left.png?v=1639469969">', '<img src="https://cdn.shopify.com/s/files/1/0197/2473/0432/files/long-arrow-right.png?v=1639469970">'],
            });
    }),
    window.addEventListener("pplrAddToCartCompleted", function (a) {
        jQuery(".cart").addClass("cart--show-indicator"),
            "out" == jQuery(".variant-selector").find("option:selected").data("stock")
                ? jQuery(".design-pre-order-template-wrapper button").replaceWith("<a id='view_cart_id' href='/cart'>View Cart</a>")
                : jQuery(".product-form-button-container button").replaceWith("<a id='view_cart_id' href='/cart'>View Cart</a>"),
            pplr_w_h(),
            jQuery(".pplr-c-button").html('Product And Disc Added <i class="fa fa-check" aria-hidden="true"></i>');
    }),
    jQuery("#notify-me").click(function () {
        return jQuery("#notify-me-wrapper").fadeIn(), !1;
    }),
    jQuery("#edit_engraving_product").click(function () {
        var a = jQuery(this).data("variantid"),
            b = jQuery(this).data("product_url");
        jQuery.ajax({
            type: "POST",
            url: "/cart/change.js",
            dataType: "json",
            data: { line: parseFloat(a), quantity: 0 },
            success: function (a) {
                window.location.href = "https://www.aspire-jewellery.com" + b;
            },
        });
    }),
    jQuery("#remove_engraving_product").click(function () {
        var a = jQuery(this).data("variantid");
        jQuery.ajax({
            type: "POST",
            url: "/cart/change.js",
            dataType: "json",
            data: { line: parseFloat(a), properties: { "1-2 weeks to make and ship": "1" } },
            success: function (a) {
                location.reload();
            },
        });
    }),
    jQuery(window).on("load", headerSize),
    jQuery(window).scroll(function () {
        $(window).scrollTop() >= 1 ? jQuery("#sticky_header").addClass("is_sticky") : jQuery("#sticky_header").removeClass("is_sticky");
    }),
    (function ($) {
        var $ = (jQuery = $),
            a = { sections: [] };
        theme.Sections = new (function () {
            var _ = this;
            (_._instances = []),
                (_._deferredSectionTargets = []),
                (_._sections = []),
                (_._deferredLoadViewportExcess = 300),
                (_._deferredWatcherRunning = !1),
                (_.init = function () {
                    $(document)
                        .on("shopify:section:load", function (b) {
                            var a = _._themeSectionTargetFromShopifySectionTarget(b.target);
                            a && _.sectionLoad(a);
                        })
                        .on("shopify:section:unload", function (b) {
                            var a = _._themeSectionTargetFromShopifySectionTarget(b.target);
                            a && _.sectionUnload(a);
                        }),
                        $(window).on("throttled-scroll.themeSectionDeferredLoader debouncedresize.themeSectionDeferredLoader", _._processDeferredSections),
                        (_._deferredWatcherRunning = !0);
                }),
                (_.register = function (b, c, a) {
                    _._sections.push({ type: b, section: c, afterSectionLoadCallback: a ? a.afterLoad : null, afterSectionUnloadCallback: a ? a.afterUnload : null }),
                        $('[data-section-type="' + b + '"]').each(function () {
                            Shopify.designMode || (a && !1 === a.deferredLoad) || !_._deferredWatcherRunning ? _.sectionLoad(this) : _.sectionDeferredLoad(this, a);
                        });
                }),
                (_.sectionDeferredLoad = function (b, a) {
                    _._deferredSectionTargets.push({ target: b, deferredLoadViewportExcess: a && a.deferredLoadViewportExcess ? a.deferredLoadViewportExcess : _._deferredLoadViewportExcess }), _._processDeferredSections(!0);
                }),
                (_._processDeferredSections = function (h) {
                    if (_._deferredSectionTargets.length)
                        for (var b = $(window).scrollTop(), d = b + $(window).height(), j = !0 === h ? _._deferredSectionTargets.length - 1 : 0, a = j; a < _._deferredSectionTargets.length; a++) {
                            var e = _._deferredSectionTargets[a].target,
                                i = _._deferredSectionTargets[a].deferredLoadViewportExcess,
                                c = $(e).offset().top - i,
                                f = c > b && c < d;
                            if (!f) {
                                var g = c + $(e).outerHeight() + 2 * i;
                                f = g > b && g < d;
                            }
                            (f || (c < b && g > d)) && (_.sectionLoad(e), _._deferredSectionTargets.splice(a, 1), a--);
                        }
                    !0 !== h && 0 === _._deferredSectionTargets.length && ((_._deferredWatcherRunning = !1), $(window).off(".themeSectionDeferredLoader"));
                }),
                (_.sectionLoad = function (a) {
                    var a = a,
                        d = _._sectionForTarget(a),
                        b = !1;
                    if (!1 !== (b = d.section ? d.section : d)) {
                        var c = { target: a, section: b, $shopifySectionContainer: $(a).closest(".shopify-section"), thisContext: { functions: b.functions } };
                        _._instances.push(c),
                            $(a).data("components") &&
                                $(a)
                                    .data("components")
                                    .split(",")
                                    .forEach(function (b) {
                                        $(document).trigger("cc:component:load", [b, a]);
                                    }),
                            _._callSectionWith(b, "onSectionLoad", a, c.thisContext),
                            _._callSectionWith(b, "afterSectionLoadCallback", a, c.thisContext),
                            b.onSectionSelect &&
                                c.$shopifySectionContainer.on("shopify:section:select", function (a) {
                                    _._callSectionWith(b, "onSectionSelect", a.target, c.thisContext);
                                }),
                            b.onSectionDeselect &&
                                c.$shopifySectionContainer.on("shopify:section:deselect", function (a) {
                                    _._callSectionWith(b, "onSectionDeselect", a.target, c.thisContext);
                                }),
                            b.onBlockSelect &&
                                $(a).on("shopify:block:select", function (a) {
                                    _._callSectionWith(b, "onBlockSelect", a.target, c.thisContext);
                                }),
                            b.onBlockDeselect &&
                                $(a).on("shopify:block:deselect", function (a) {
                                    _._callSectionWith(b, "onBlockDeselect", a.target, c.thisContext);
                                });
                    }
                }),
                (_.sectionUnload = function (b) {
                    for (var e = _._sectionForTarget(b), c = -1, a = 0; a < _._instances.length; a++) _._instances[a].target == b && (c = a);
                    if (c > -1) {
                        var d = _._instances[c];
                        $(b).off("shopify:block:select shopify:block:deselect"),
                            d.$shopifySectionContainer.off("shopify:section:select shopify:section:deselect"),
                            _._callSectionWith(d.section, "onSectionUnload", b, d.thisContext),
                            _._callSectionWith(e, "afterSectionUnloadCallback", b, d.thisContext),
                            _._instances.splice(c),
                            $(b).data("components") &&
                                $(b)
                                    .data("components")
                                    .split(",")
                                    .forEach(function (a) {
                                        $(document).trigger("cc:component:unload", [a, b]);
                                    });
                    } else
                        for (var a = 0; a < _._deferredSectionTargets.length; a++)
                            if (_._deferredSectionTargets[a].target == b) {
                                _._deferredSectionTargets[a].splice(a, 1);
                                break;
                            }
                }),
                (_._callSectionWith = function (c, a, b, d) {
                    if ("function" == typeof c[a])
                        try {
                            d ? c[a].bind(d)(b) : c[a](b);
                        } catch (e) {
                            var f = b.dataset.sectionType;
                            console.log("Theme warning: '".concat(a, "' failed for section '").concat(f, "'")), console.debug(b, e.stack);
                        }
                }),
                (_._themeSectionTargetFromShopifySectionTarget = function (b) {
                    var a = $("[data-section-type]:first", b);
                    return a.length > 0 && a[0];
                }),
                (_._sectionForTarget = function (b) {
                    for (var c = $(b).attr("data-section-type"), a = 0; a < _._sections.length; a++) if (_._sections[a].type == c) return _._sections[a];
                    return !1;
                }),
                (_._sectionAlreadyRegistered = function (b) {
                    for (var a = 0; a < _._sections.length; a++) if (_._sections[a].type == b) return !0;
                    return !1;
                });
        })();
        var c,
            b = (function () {
                "use strict";
                function a(b) {
                    var c = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-".concat(b);
                    _classCallCheck(this, a);
                    var d = this;
                    (this.instances = []),
                        $(document).on("cc:component:load", function (f, a, e) {
                            a === b &&
                                $(e)
                                    .find("".concat(c, ":not(.cc-initialized)"))
                                    .each(function () {
                                        d.init(this);
                                    });
                        }),
                        $(document).on("cc:component:unload", function (f, a, e) {
                            a === b &&
                                $(e)
                                    .find(c)
                                    .each(function () {
                                        d.destroy(this);
                                    });
                        }),
                        $(c).each(function () {
                            d.init(this);
                        });
                }
                return (
                    _createClass(a, [
                        {
                            key: "init",
                            value: function (a) {
                                $(a).addClass("cc-initialized");
                            },
                        },
                        {
                            key: "destroy",
                            value: function (a) {
                                $(a).removeClass("cc-initialized");
                            },
                        },
                        {
                            key: "registerInstance",
                            value: function (a, b) {
                                this.instances.push({ container: a, instance: b });
                            },
                        },
                        {
                            key: "destroyInstance",
                            value: function (a) {
                                this.instances = this.instances.filter(function (b) {
                                    if (b.container === a) return "function" == typeof b.instance.destroy && b.instance.destroy(), b.container !== a;
                                });
                            },
                        },
                    ]),
                    a
                );
            })();
        (c = document.createEvent("Event")).initEvent("throttled-scroll", !0, !0),
            window.addEventListener(
                "scroll",
                (function (a, b) {
                    var c = -1,
                        d = !1;
                    return function () {
                        clearTimeout(c),
                            (c = setTimeout(a, b)),
                            d ||
                                (a.call(),
                                (d = !0),
                                setTimeout(function () {
                                    d = !1;
                                }, b));
                    };
                })(function () {
                    window.dispatchEvent(c);
                }, 200)
            ),
            (theme.Shopify = {
                formatMoney: function (a, f) {
                    function g(a, b) {
                        return void 0 === a ? b : a;
                    }
                    function c(a, b, c, d) {
                        if (((b = g(b, 2)), (c = g(c, ",")), (d = g(d, ".")), isNaN(a) || null == a)) return 0;
                        var e = (a = (a / 100).toFixed(b)).split(".");
                        return e[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + c) + (e[1] ? d + e[1] : "");
                    }
                    "string" == typeof a && (a = a.replace(".", ""));
                    var b = "",
                        d = /\{\{\s*(\w+)\s*\}\}/,
                        e = f || this.money_format;
                    switch (e.match(d)[1]) {
                        case "amount":
                            b = c(a, 2);
                            break;
                        case "amount_no_decimals":
                            b = c(a, 0);
                            break;
                        case "amount_with_comma_separator":
                            b = c(a, 2, ".", ",");
                            break;
                        case "amount_with_space_separator":
                            b = c(a, 2, " ", ",");
                            break;
                        case "amount_with_period_and_space_separator":
                            b = c(a, 2, " ", ".");
                            break;
                        case "amount_no_decimals_with_comma_separator":
                            b = c(a, 0, ".", ",");
                            break;
                        case "amount_no_decimals_with_space_separator":
                            b = c(a, 0, " ", "");
                            break;
                        case "amount_with_apostrophe_separator":
                            b = c(a, 2, "'", ".");
                            break;
                        case "amount_with_decimal_separator":
                            b = c(a, 2, ".", ".");
                    }
                    return e.replace(d, b);
                },
                formatImage: function (a, b) {
                    return a ? a.replace(/^(.*)\.([^\.]*)$/g, "$1_" + b + ".$2") : "";
                },
                Image: {
                    imageSize: function (b) {
                        var a = b.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
                        return null !== a ? a[1] : null;
                    },
                    getSizedImageUrl: function (a, b) {
                        if (null == b) return a;
                        if ("master" == b) return this.removeProtocol(a);
                        var c = a.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                        if (null != c) {
                            var d = a.split(c[0]),
                                e = c[0];
                            return this.removeProtocol(d[0] + "_" + b + e);
                        }
                        return null;
                    },
                    removeProtocol: function (a) {
                        return a.replace(/http(s)?:/, "");
                    },
                },
            }),
            ($.fn.clickyBoxes = function (a) {
                if ("destroy" != a)
                    return $(this)
                        .filter("select:not(.clickybox-replaced)")
                        .addClass("clickybox-replaced")
                        .each(function () {
                            var a,
                                b = b || $(this).attr("id"),
                                c = $('<ul class="clickyboxes"/>')
                                    .attr("id", "clickyboxes-" + b)
                                    .data("select", $(this))
                                    .insertAfter(this);
                            (a = $(this).is("[id]") ? $('label[for="' + $(this).attr("id") + '"]') : $(this).siblings("label")).length > 0 &&
                                c.addClass(
                                    "options-" +
                                        removeDiacritics(a.text())
                                            .toLowerCase()
                                            .replace(/'/g, "")
                                            .replace(/[^a-z0-9]+/g, "-")
                                            .replace(/-+/g, "-")
                                            .replace(/-*$/, "")
                                ),
                                $(this)
                                    .find("option")
                                    .each(function () {
                                        $("<li/>")
                                            .appendTo(c)
                                            .append(
                                                $('<a href="#"/>')
                                                    .attr("data-value", $(this).val())
                                                    .html($(this).html())
                                                    .addClass(
                                                        "opt--" +
                                                            removeDiacritics($(this).text())
                                                                .toLowerCase()
                                                                .replace(/'/g, "")
                                                                .replace(/[^a-z0-9]+/g, "-")
                                                                .replace(/-+/g, "-")
                                                                .replace(/-*$/, "")
                                                    )
                                            );
                                    }),
                                $(this)
                                    .hide()
                                    .addClass("replaced")
                                    .on("change.clickyboxes keyup.clickyboxes", function () {
                                        var a = $(this).val();
                                        c.find("a")
                                            .removeClass("active")
                                            .filter(function () {
                                                return $(this).attr("data-value") == a;
                                            })
                                            .addClass("active");
                                    })
                                    .trigger("keyup"),
                                c.on("click.clickyboxes", "a", function () {
                                    if (!$(this).hasClass("active")) {
                                        var a = $(this).closest(".clickyboxes");
                                        a.data("select").val($(this).data("value")).trigger("change"), a.trigger("change");
                                    }
                                    return !1;
                                });
                        });
                $(this).off(".clickyboxes"), $(this).next(".clickyboxes").off(".clickyboxes");
            }),
            (theme.Disclosure = (function () {
                var b = { disclosureList: "[data-disclosure-list]", disclosureToggle: "[data-disclosure-toggle]", disclosureInput: "[data-disclosure-input]", disclosureOptions: "[data-disclosure-option]" },
                    c = { listVisible: "disclosure-list--visible" };
                function a(a) {
                    (this.$container = a), (this.cache = {}), this._cacheSelectors(), this._connectOptions(), this._connectToggle(), this._onFocusOut();
                }
                return (
                    (a.prototype = $.extend({}, a.prototype, {
                        _cacheSelectors: function () {
                            this.cache = {
                                $disclosureList: this.$container.find(b.disclosureList),
                                $disclosureToggle: this.$container.find(b.disclosureToggle),
                                $disclosureInput: this.$container.find(b.disclosureInput),
                                $disclosureOptions: this.$container.find(b.disclosureOptions),
                            };
                        },
                        _connectToggle: function () {
                            this.cache.$disclosureToggle.on(
                                "click",
                                function (a) {
                                    var b = "true" === $(a.currentTarget).attr("aria-expanded");
                                    $(a.currentTarget).attr("aria-expanded", !b), this.cache.$disclosureList.toggleClass(c.listVisible);
                                }.bind(this)
                            );
                        },
                        _connectOptions: function () {
                            this.cache.$disclosureOptions.on(
                                "click",
                                function (a) {
                                    a.preventDefault(), this._submitForm($(a.currentTarget).data("value"));
                                }.bind(this)
                            );
                        },
                        _onFocusOut: function () {
                            this.cache.$disclosureToggle.on(
                                "focusout",
                                function (a) {
                                    0 === this.$container.has(a.relatedTarget).length && this._hideList();
                                }.bind(this)
                            ),
                                this.cache.$disclosureList.on(
                                    "focusout",
                                    function (a) {
                                        var b = $(a.currentTarget).has(a.relatedTarget).length > 0;
                                        this.cache.$disclosureList.hasClass(c.listVisible) && !b && this._hideList();
                                    }.bind(this)
                                ),
                                this.$container.on(
                                    "keyup",
                                    function (a) {
                                        27 === a.which && (this._hideList(), this.cache.$disclosureToggle.focus());
                                    }.bind(this)
                                ),
                                (this.bodyOnClick = function (a) {
                                    var b = this.$container.has(a.target).length > 0;
                                    this.cache.$disclosureList.hasClass(c.listVisible) && !b && this._hideList();
                                }.bind(this)),
                                $("body").on("click", this.bodyOnClick);
                        },
                        _submitForm: function (a) {
                            this.cache.$disclosureInput.val(a), this.$container.parents("form").submit();
                        },
                        _hideList: function () {
                            this.cache.$disclosureList.removeClass(c.listVisible), this.cache.$disclosureToggle.attr("aria-expanded", !1);
                        },
                        unload: function () {
                            $("body").off("click", this.bodyOnClick), this.cache.$disclosureOptions.off(), this.cache.$disclosureToggle.off(), this.cache.$disclosureList.off(), this.$container.off();
                        },
                    })),
                    a
                );
            })()),
            (theme.scriptsLoaded = {}),
            (theme.loadScriptOnce = function (a, b, d, f) {
                if (void 0 === theme.scriptsLoaded[a]) {
                    theme.scriptsLoaded[a] = [];
                    var c = document.createElement("script");
                    (c.src = a),
                        (f || d) && (c.async = !1),
                        d && d(),
                        "function" == typeof b &&
                            (theme.scriptsLoaded[a].push(b),
                            c.readyState
                                ? (c.onreadystatechange = function () {
                                      if ("loaded" == c.readyState || "complete" == c.readyState) {
                                          c.onreadystatechange = null;
                                          for (var a = 0; a < theme.scriptsLoaded[this].length; a++) theme.scriptsLoaded[this][a]();
                                          theme.scriptsLoaded[this] = !0;
                                      }
                                  }.bind(a))
                                : (c.onload = function () {
                                      for (var a = 0; a < theme.scriptsLoaded[this].length; a++) theme.scriptsLoaded[this][a]();
                                      theme.scriptsLoaded[this] = !0;
                                  }.bind(a)));
                    var e = document.getElementsByTagName("script")[0];
                    return e.parentNode.insertBefore(c, e), !0;
                }
                if ("object" !== _typeof(theme.scriptsLoaded[a]) || "function" != typeof b) return "function" == typeof b && b(), !1;
                theme.scriptsLoaded[a].push(b);
            }),
            (theme.loadStyleOnce = function (d) {
                var b = d.replace(/^https?:/, "");
                if (!document.querySelector('link[href="' + encodeURI(b) + '"]')) {
                    var a = document.createElement("link");
                    (a.href = b), (a.rel = "stylesheet"), (a.type = "text/css");
                    var c = document.getElementsByTagName("link")[0];
                    c.parentNode.insertBefore(a, c);
                }
            }),
            (theme.cartNoteMonitor = {
                load: function (a) {
                    a.on("change.themeCartNoteMonitor paste.themeCartNoteMonitor keyup.themeCartNoteMonitor", function () {
                        theme.cartNoteMonitor.postUpdate($(this).val());
                    });
                },
                unload: function (a) {
                    a.off(".themeCartNoteMonitor");
                },
                updateThrottleTimeoutId: -1,
                updateThrottleInterval: 500,
                postUpdate: function (a) {
                    clearTimeout(theme.cartNoteMonitor.updateThrottleTimeoutId),
                        (theme.cartNoteMonitor.updateThrottleTimeoutId = setTimeout(function () {
                            $.post(theme.routes.cart_url + "/update.js", { note: a }, function (a) {}, "json");
                        }, theme.cartNoteMonitor.updateThrottleInterval));
                },
            });
        var e = (function () {
            "use strict";
            function a(b) {
                _classCallCheck(this, a),
                    (this.filteringEnabled = "true" === b.dataset.filtering),
                    (this.sortingEnabled = "true" === b.dataset.sorting),
                    (this.filtersControl = document.querySelector(".cc-filters-control")),
                    (this.filtersContainer = document.querySelector(".cc-filters-container")),
                    (this.results = document.querySelector(".cc-filters-results")),
                    this.filteringEnabled &&
                        ((this.filters = document.querySelector(".cc-filters")),
                        (this.filtersFooter = document.querySelector(".cc-filters__footer")),
                        (this.activeFilters = document.querySelector(".cc-active-filters")),
                        (this.clearFiltersBtn = document.querySelector(".js-clear-filters"))),
                    this.sortingEnabled && ((this.sortBy = document.querySelector(".cc-filter--sort")), (this.activeSortText = document.querySelector(".cc-sort-selected"))),
                    (this.utils = { hidden: "is-hidden", loading: "is-loading", open: "is-open", filtersOpen: "filters-open" }),
                    this.filteringEnabled && !this.filtersFooter.classList.contains(this.utils.hidden) && (this.filters.style.height = "calc(100% - ".concat(this.filtersFooter.offsetHeight, "px)")),
                    this.bindEvents();
            }
            return (
                _createClass(a, [
                    {
                        key: "bindEvents",
                        value: function () {
                            this.filtersControl.addEventListener("click", this.handleControlClick.bind(this)),
                                this.filtersContainer.addEventListener("click", this.handleFiltersClick.bind(this)),
                                this.filtersContainer.addEventListener("input", this.debounce(this.handleFilterChange.bind(this), 500)),
                                this.filteringEnabled &&
                                    (document.querySelector(".cc-price-range") && this.filtersContainer.addEventListener("change", this.debounce(this.handleFilterChange.bind(this), 500)),
                                    this.activeFilters.addEventListener("click", this.handleActiveFiltersClick.bind(this))),
                                document.addEventListener("click", this.handleClickOutside.bind(this)),
                                window.addEventListener("popstate", this.handleHistoryChange.bind(this));
                        },
                    },
                    {
                        key: "debounce",
                        value: function (a, b) {
                            var c,
                                d = this;
                            return function () {
                                for (var f = arguments.length, g = new Array(f), e = 0; e < f; e++) g[e] = arguments[e];
                                clearTimeout(c),
                                    (c = setTimeout(function () {
                                        return a.apply(d, g);
                                    }, b));
                            };
                        },
                    },
                    {
                        key: "handleControlClick",
                        value: function (a) {
                            var b = this;
                            a.target.matches(".cc-filters-control__btn") &&
                                (document.body.classList.add(this.utils.filtersOpen),
                                a.target.matches(".js-show-filters")
                                    ? this.filters.classList.add(this.utils.open)
                                    : ((this.sortBy.open = !0),
                                      setTimeout(function () {
                                          b.sortBy.classList.add(b.utils.open);
                                      }, 10)));
                        },
                    },
                    {
                        key: "handleFiltersClick",
                        value: function (a) {
                            var e = this,
                                b = a.target,
                                c = b.closest(".cc-filter");
                            if (b.matches(".cc-filter-clear-btn")) {
                                a.preventDefault(), this.applyFilters(new URL(a.target.href).searchParams.toString(), a);
                                return;
                            }
                            if (b.matches(".js-close-filters")) {
                                c &&
                                    setTimeout(function () {
                                        c.classList.remove(e.utils.open), (c.open = !1);
                                    }, 300),
                                    this.filteringEnabled && this.filters.classList.remove(this.utils.open),
                                    document.body.classList.remove(this.utils.filtersOpen);
                                return;
                            }
                            if (b.matches(".cc-filter__toggle") || b.matches(".cc-filter-back-btn")) {
                                var d = document.querySelector('.cc-filter[open]:not([data-index="'.concat(c.dataset.index, '"])'));
                                d && this.closeFilter(d, !1),
                                    c.classList.contains(this.utils.open)
                                        ? (a.preventDefault(), this.closeFilter(c))
                                        : setTimeout(function () {
                                              c.classList.add(e.utils.open);
                                          }, 10);
                            }
                        },
                    },
                    {
                        key: "handleClickOutside",
                        value: function (b) {
                            var a = document.querySelector(".cc-filter.".concat(this.utils.open));
                            if (a) {
                                var c = b.target.closest(".cc-filter");
                                (c && c === a) || (b.preventDefault(), this.closeFilter(a));
                            }
                        },
                    },
                    {
                        key: "handleFilterChange",
                        value: function (a) {
                            if ("change" !== a.type || (a.detail && "theme:component:price_range" === a.detail.sender)) {
                                "input" === a.type && a.target.classList.contains("cc-price-range__input") && a.target.dispatchEvent(new Event("change", { bubbles: !0 }));
                                var b = new FormData(document.getElementById("filters")),
                                    c = new URLSearchParams(b);
                                this.applyFilters(c.toString(), a);
                            }
                        },
                    },
                    {
                        key: "handleActiveFiltersClick",
                        value: function (a) {
                            a.preventDefault(), "A" === a.target.tagName && this.applyFilters(new URL(a.target.href).searchParams.toString(), a);
                        },
                    },
                    {
                        key: "handleHistoryChange",
                        value: function (a) {
                            var b = "";
                            a.state && a.state.searchParams && (b = a.state.searchParams), this.applyFilters(b, null, !1);
                        },
                    },
                    {
                        key: "applyFilters",
                        value: function (a, c) {
                            var d = this,
                                b = !(arguments.length > 2) || void 0 === arguments[2] || arguments[2];
                            this.results.classList.add(this.utils.loading),
                                fetch("".concat(window.location.pathname, "?").concat(a))
                                    .then(function (a) {
                                        return a.text();
                                    })
                                    .then(function (b) {
                                        var a = new DOMParser().parseFromString(b, "text/html");
                                        d.updateFilters(a, c),
                                            (d.results.innerHTML = a.querySelector(".cc-filters-results").innerHTML),
                                            document.dispatchEvent(new CustomEvent("filters-applied", { bubbles: !0 })),
                                            d.results.classList.remove(d.utils.loading);
                                    }),
                                b && this.updateURL(a);
                        },
                    },
                    {
                        key: "updateFilters",
                        value: function (a, b) {
                            var e = this;
                            if (
                                ((this.filtersControl.innerHTML = a.querySelector(".cc-filters-control").innerHTML),
                                b && "sort_by" === b.target.name && (this.activeSortText.textContent = b.target.nextElementSibling.textContent),
                                this.filteringEnabled)
                            ) {
                                document.querySelectorAll(".cc-filter").forEach(function (c) {
                                    var f = c.dataset.index;
                                    if ("0" !== f) {
                                        var d = a.querySelector('.cc-filter[data-index="'.concat(f, '"]'));
                                        if ("price_range" === c.dataset.type)
                                            e.updateFilter(c, d, !1),
                                                (b && "INPUT" === b.target.tagName) ||
                                                    c.querySelectorAll("input").forEach(function (b) {
                                                        (b.value = a.getElementById(b.id).value), b.dispatchEvent(new CustomEvent("change", { bubbles: !0, detail: { sender: "reset" } }));
                                                    });
                                        else if (b && "INPUT" === b.target.tagName) {
                                            var g = b.target.closest(".cc-filter");
                                            e.updateFilter(c, d, c.dataset.index !== g.dataset.index);
                                        } else e.updateFilter(c, d, !0);
                                    }
                                }),
                                    this.updateActiveFilters(a),
                                    (this.clearFiltersBtn.hidden = a.querySelector(".js-clear-filters").hidden);
                                var c = a.querySelector(".cc-filters__footer"),
                                    d = c.classList.contains(this.utils.hidden);
                                (this.filtersFooter.innerHTML = c.innerHTML), this.filtersFooter.classList.toggle(this.utils.hidden, d), (this.filters.style.height = d ? null : "calc(100% - ".concat(this.filtersFooter.offsetHeight, "px)"));
                            }
                        },
                    },
                    {
                        key: "updateFilter",
                        value: function (a, b, c) {
                            c
                                ? (a.innerHTML = b.innerHTML)
                                : (a.replaceChild(b.querySelector(".cc-filter__toggle"), a.querySelector(".cc-filter__toggle")), (a.querySelector(".cc-filter__header").innerHTML = b.querySelector(".cc-filter__header").innerHTML));
                        },
                    },
                    {
                        key: "updateActiveFilters",
                        value: function (a) {
                            var b = a.querySelector(".cc-active-filters");
                            (this.activeFilters.innerHTML = b.innerHTML), (this.activeFilters.hidden = !this.activeFilters.querySelector(".cc-active-filter"));
                        },
                    },
                    {
                        key: "updateURL",
                        value: function (a) {
                            history.pushState({ searchParams: a }, "", "".concat(window.location.pathname).concat(a && "?".concat(a)));
                        },
                    },
                    {
                        key: "closeFilter",
                        value: function (a) {
                            var b = !(arguments.length > 1) || void 0 === arguments[1] || arguments[1];
                            clearTimeout(this.closeTimer),
                                a.classList.remove(this.utils.open),
                                (this.closeTimer = setTimeout(
                                    function () {
                                        a.open = !1;
                                    },
                                    b ? 300 : null
                                ));
                        },
                    },
                ]),
                a
            );
        })();
        new ((function (b) {
            "use strict";
            _inherits(a, b);
            var c = _createSuper(a);
            function a() {
                var b = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "facet-filters",
                    d = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-facet-filters";
                return _classCallCheck(this, a), c.call(this, b, d);
            }
            return (
                _createClass(a, [
                    {
                        key: "init",
                        value: function (b) {
                            _get(_getPrototypeOf(a.prototype), "init", this).call(this, b), this.registerInstance(b, new e(b));
                        },
                    },
                    {
                        key: "destroy",
                        value: function (b) {
                            this.destroyInstance(b), _get(_getPrototypeOf(a.prototype), "destroy", this).call(this, b);
                        },
                    },
                ]),
                a
            );
        })(b))();
        var f = (function () {
            "use strict";
            function a(b) {
                var c = this;
                _classCallCheck(this, a),
                    (this.container = b),
                    (this.selectors = {
                        inputMin: ".cc-price-range__input--min",
                        inputMax: ".cc-price-range__input--max",
                        control: ".cc-price-range__control",
                        controlMin: ".cc-price-range__control--min",
                        controlMax: ".cc-price-range__control--max",
                        bar: ".cc-price-range__bar",
                        activeBar: ".cc-price-range__bar-active",
                    }),
                    (this.controls = {
                        min: { barControl: b.querySelector(this.selectors.controlMin), input: b.querySelector(this.selectors.inputMin) },
                        max: { barControl: b.querySelector(this.selectors.controlMax), input: b.querySelector(this.selectors.inputMax) },
                    }),
                    (this.controls.min.value = parseInt("" === this.controls.min.input.value ? this.controls.min.input.placeholder : this.controls.min.input.value)),
                    (this.controls.max.value = parseInt("" === this.controls.max.input.value ? this.controls.max.input.placeholder : this.controls.max.input.value)),
                    (this.valueMin = this.controls.min.input.min),
                    (this.valueMax = this.controls.min.input.max),
                    (this.valueRange = this.valueMax - this.valueMin),
                    [this.controls.min, this.controls.max].forEach(function (a) {
                        a.barControl.setAttribute("aria-valuemin", c.valueMin), a.barControl.setAttribute("aria-valuemax", c.valueMax);
                    }),
                    this.controls.min.barControl.setAttribute("aria-valuenow", this.controls.min.value),
                    this.controls.max.barControl.setAttribute("aria-valuenow", this.controls.max.value),
                    (this.bar = b.querySelector(this.selectors.bar)),
                    (this.activeBar = b.querySelector(this.selectors.activeBar)),
                    (this.inDrag = !1),
                    this.bindEvents(),
                    this.render();
            }
            return (
                _createClass(a, [
                    {
                        key: "getPxToValueRatio",
                        value: function () {
                            return this.bar.clientWidth / (this.valueMax - this.valueMin);
                        },
                    },
                    {
                        key: "getPcToValueRatio",
                        value: function () {
                            return 100 / (this.valueMax - this.valueMin);
                        },
                    },
                    {
                        key: "setActiveControlValue",
                        value: function (a, b) {
                            this.activeControl === this.controls.min
                                ? ("" === a && (a = this.valueMin), (a = Math.max(this.valueMin, a)), (a = Math.min(a, this.controls.max.value)))
                                : ("" === a && (a = this.valueMax), (a = Math.min(this.valueMax, a)), (a = Math.max(a, this.controls.min.value))),
                                (this.activeControl.value = Math.round(a)),
                                this.activeControl.input.value == this.activeControl.value ||
                                    (this.activeControl.value == this.activeControl.input.placeholder ? (this.activeControl.input.value = "") : (this.activeControl.input.value = this.activeControl.value),
                                    b || this.activeControl.input.dispatchEvent(new CustomEvent("change", { bubbles: !0, detail: { sender: "theme:component:price_range" } }))),
                                this.activeControl.barControl.setAttribute("aria-valuenow", this.activeControl.value);
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            this.drawControl(this.controls.min), this.drawControl(this.controls.max), this.drawActiveBar();
                        },
                    },
                    {
                        key: "drawControl",
                        value: function (a) {
                            a.barControl.style.left = "".concat((a.value - this.valueMin) * this.getPcToValueRatio(), "%");
                        },
                    },
                    {
                        key: "drawActiveBar",
                        value: function () {
                            (this.activeBar.style.left = "".concat((this.controls.min.value - this.valueMin) * this.getPcToValueRatio(), "%")),
                                (this.activeBar.style.right = "".concat((this.valueMax - this.controls.max.value) * this.getPcToValueRatio(), "%"));
                        },
                    },
                    {
                        key: "handleControlTouchStart",
                        value: function (a) {
                            a.preventDefault(),
                                this.startDrag(a.target, a.touches[0].clientX),
                                (this.boundControlTouchMoveEvent = this.handleControlTouchMove.bind(this)),
                                (this.boundControlTouchEndEvent = this.handleControlTouchEnd.bind(this)),
                                window.addEventListener("touchmove", this.boundControlTouchMoveEvent),
                                window.addEventListener("touchend", this.boundControlTouchEndEvent);
                        },
                    },
                    {
                        key: "handleControlTouchMove",
                        value: function (a) {
                            this.moveDrag(a.touches[0].clientX);
                        },
                    },
                    {
                        key: "handleControlTouchEnd",
                        value: function (a) {
                            a.preventDefault(), window.removeEventListener("touchmove", this.boundControlTouchMoveEvent), window.removeEventListener("touchend", this.boundControlTouchEndEvent), this.stopDrag();
                        },
                    },
                    {
                        key: "handleControlMouseDown",
                        value: function (a) {
                            a.preventDefault(),
                                this.startDrag(a.target, a.clientX),
                                (this.boundControlMouseMoveEvent = this.handleControlMouseMove.bind(this)),
                                (this.boundControlMouseUpEvent = this.handleControlMouseUp.bind(this)),
                                window.addEventListener("mousemove", this.boundControlMouseMoveEvent),
                                window.addEventListener("mouseup", this.boundControlMouseUpEvent);
                        },
                    },
                    {
                        key: "handleControlMouseMove",
                        value: function (a) {
                            this.moveDrag(a.clientX);
                        },
                    },
                    {
                        key: "handleControlMouseUp",
                        value: function (a) {
                            a.preventDefault(), window.removeEventListener("mousemove", this.boundControlMouseMoveEvent), window.removeEventListener("mouseup", this.boundControlMouseUpEvent), this.stopDrag();
                        },
                    },
                    {
                        key: "startDrag",
                        value: function (a, b) {
                            (this.activeControl = this.controls.min.barControl === a ? this.controls.min : this.controls.max), (this.dragStartX = b), (this.dragStartValue = this.activeControl.value), (this.inDrag = !0);
                        },
                    },
                    {
                        key: "moveDrag",
                        value: function (a) {
                            if (this.inDrag) {
                                var b = this.dragStartValue + (a - this.dragStartX) / this.getPxToValueRatio();
                                this.setActiveControlValue(b), this.render();
                            }
                        },
                    },
                    {
                        key: "stopDrag",
                        value: function () {
                            this.inDrag = !1;
                        },
                    },
                    {
                        key: "handleInputChange",
                        value: function (a) {
                            if ("INPUT" === a.target.tagName && (!a.detail || "theme:component:price_range" !== a.detail.sender)) {
                                var b = a.detail && "reset" === a.detail.sender;
                                (this.activeControl = this.controls.min.input === a.target ? this.controls.min : this.controls.max), this.setActiveControlValue(a.target.value, b), this.render();
                            }
                        },
                    },
                    {
                        key: "bindEvents",
                        value: function () {
                            var a = this;
                            [this.controls.min, this.controls.max].forEach(function (b) {
                                b.barControl.addEventListener("touchstart", a.handleControlTouchStart.bind(a)), b.barControl.addEventListener("mousedown", a.handleControlMouseDown.bind(a));
                            }),
                                this.container.addEventListener("change", this.handleInputChange.bind(this));
                        },
                    },
                    { key: "destroy", value: function () {} },
                ]),
                a
            );
        })();
        new ((function (b) {
            "use strict";
            _inherits(a, b);
            var c = _createSuper(a);
            function a() {
                var b = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "price-range",
                    d = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-".concat(b);
                return _classCallCheck(this, a), c.call(this, b, d);
            }
            return (
                _createClass(a, [
                    {
                        key: "init",
                        value: function (b) {
                            _get(_getPrototypeOf(a.prototype), "init", this).call(this, b), this.registerInstance(b, new f(b));
                        },
                    },
                    {
                        key: "destroy",
                        value: function (b) {
                            this.destroyInstance(b), _get(_getPrototypeOf(a.prototype), "destroy", this).call(this, b);
                        },
                    },
                ]),
                a
            );
        })(b))();
        var d,
            g = (function () {
                "use strict";
                function a(b, c) {
                    _classCallCheck(this, a), (this.$container = b), (this.namespace = c), (this.cssClasses = { visible: "cc-popup--visible", bodyNoScroll: "cc-popup-no-scroll", bodyNoScrollPadRight: "cc-popup-no-scroll-pad-right" });
                }
                return (
                    _createClass(a, [
                        {
                            key: "open",
                            value: function (b) {
                                var d = this;
                                if (this.$container.data("freeze-scroll")) {
                                    $("body").addClass(this.cssClasses.bodyNoScroll);
                                    var a = document.createElement("div");
                                    (a.className = "popup-scrollbar-measure"), document.body.appendChild(a);
                                    var c = a.getBoundingClientRect().width - a.clientWidth;
                                    document.body.removeChild(a),
                                        c > 0 &&
                                            $("body")
                                                .css("padding-right", c + "px")
                                                .addClass(this.cssClasses.bodyNoScrollPadRight);
                                }
                                this.$container.addClass(this.cssClasses.visible),
                                    (this.previouslyActiveElement = document.activeElement),
                                    setTimeout(function () {
                                        d.$container.find(".cc-popup-close")[0].focus();
                                    }, 500),
                                    $(window).on("keydown" + this.namespace, function (a) {
                                        27 === a.keyCode && d.close();
                                    }),
                                    b && b();
                            },
                        },
                        {
                            key: "close",
                            value: function (b) {
                                var d = this;
                                if (
                                    (this.$container.removeClass(this.cssClasses.visible),
                                    this.previouslyActiveElement && $(this.previouslyActiveElement).focus(),
                                    $(window).off("keydown" + this.namespace),
                                    this.$container.data("freeze-scroll"))
                                ) {
                                    var a = 500,
                                        c = this.$container.find(".cc-popup-modal");
                                    c.length && (a = parseFloat(getComputedStyle(c[0]).transitionDuration)) && a > 0 && (a *= 1e3),
                                        setTimeout(function () {
                                            $("body").removeClass(d.cssClasses.bodyNoScroll).removeClass(d.cssClasses.bodyNoScrollPadRight).css("padding-right", "0");
                                        }, a);
                                }
                                b && b();
                            },
                        },
                    ]),
                    a
                );
            })();
        (theme.MapSection = new (function () {
            var _ = this;
            (_.config = {
                zoom: 14,
                styles: {
                    default: [],
                    silver: [
                        { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
                        { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
                        { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                        { elementType: "labels.text.stroke", stylers: [{ color: "#f5f5f5" }] },
                        { featureType: "administrative.land_parcel", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
                        { featureType: "poi", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
                        { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                        { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
                        { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                        { featureType: "road", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
                        { featureType: "road.arterial", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                        { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#dadada" }] },
                        { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                        { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                        { featureType: "transit.line", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
                        { featureType: "transit.station", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
                        { featureType: "water", elementType: "geometry", stylers: [{ color: "#c9c9c9" }] },
                        { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                    ],
                    retro: [
                        { elementType: "geometry", stylers: [{ color: "#ebe3cd" }] },
                        { elementType: "labels.text.fill", stylers: [{ color: "#523735" }] },
                        { elementType: "labels.text.stroke", stylers: [{ color: "#f5f1e6" }] },
                        { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#c9b2a6" }] },
                        { featureType: "administrative.land_parcel", elementType: "geometry.stroke", stylers: [{ color: "#dcd2be" }] },
                        { featureType: "administrative.land_parcel", elementType: "labels.text.fill", stylers: [{ color: "#ae9e90" }] },
                        { featureType: "landscape.natural", elementType: "geometry", stylers: [{ color: "#dfd2ae" }] },
                        { featureType: "poi", elementType: "geometry", stylers: [{ color: "#dfd2ae" }] },
                        { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#93817c" }] },
                        { featureType: "poi.park", elementType: "geometry.fill", stylers: [{ color: "#a5b076" }] },
                        { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#447530" }] },
                        { featureType: "road", elementType: "geometry", stylers: [{ color: "#f5f1e6" }] },
                        { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#fdfcf8" }] },
                        { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#f8c967" }] },
                        { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#e9bc62" }] },
                        { featureType: "road.highway.controlled_access", elementType: "geometry", stylers: [{ color: "#e98d58" }] },
                        { featureType: "road.highway.controlled_access", elementType: "geometry.stroke", stylers: [{ color: "#db8555" }] },
                        { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#806b63" }] },
                        { featureType: "transit.line", elementType: "geometry", stylers: [{ color: "#dfd2ae" }] },
                        { featureType: "transit.line", elementType: "labels.text.fill", stylers: [{ color: "#8f7d77" }] },
                        { featureType: "transit.line", elementType: "labels.text.stroke", stylers: [{ color: "#ebe3cd" }] },
                        { featureType: "transit.station", elementType: "geometry", stylers: [{ color: "#dfd2ae" }] },
                        { featureType: "water", elementType: "geometry.fill", stylers: [{ color: "#b9d3c2" }] },
                        { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#92998d" }] },
                    ],
                    dark: [
                        { elementType: "geometry", stylers: [{ color: "#212121" }] },
                        { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
                        { elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                        { elementType: "labels.text.stroke", stylers: [{ color: "#212121" }] },
                        { featureType: "administrative", elementType: "geometry", stylers: [{ color: "#757575" }] },
                        { featureType: "administrative.country", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                        { featureType: "administrative.land_parcel", stylers: [{ visibility: "off" }] },
                        { featureType: "administrative.locality", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
                        { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                        { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#181818" }] },
                        { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                        { featureType: "poi.park", elementType: "labels.text.stroke", stylers: [{ color: "#1b1b1b" }] },
                        { featureType: "road", elementType: "geometry.fill", stylers: [{ color: "#2c2c2c" }] },
                        { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#8a8a8a" }] },
                        { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#373737" }] },
                        { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#3c3c3c" }] },
                        { featureType: "road.highway.controlled_access", elementType: "geometry", stylers: [{ color: "#4e4e4e" }] },
                        { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                        { featureType: "transit", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                        { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }] },
                        { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#3d3d3d" }] },
                    ],
                    night: [
                        { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
                        { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
                        { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
                        { featureType: "administrative.locality", elementType: "labels.text.fill", stylers: [{ color: "#d59563" }] },
                        { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#d59563" }] },
                        { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#263c3f" }] },
                        { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#6b9a76" }] },
                        { featureType: "road", elementType: "geometry", stylers: [{ color: "#38414e" }] },
                        { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#212a37" }] },
                        { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#9ca5b3" }] },
                        { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#746855" }] },
                        { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#1f2835" }] },
                        { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#f3d19c" }] },
                        { featureType: "transit", elementType: "geometry", stylers: [{ color: "#2f3948" }] },
                        { featureType: "transit.station", elementType: "labels.text.fill", stylers: [{ color: "#d59563" }] },
                        { featureType: "water", elementType: "geometry", stylers: [{ color: "#17263c" }] },
                        { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#515c6d" }] },
                        { featureType: "water", elementType: "labels.text.stroke", stylers: [{ color: "#17263c" }] },
                    ],
                    aubergine: [
                        { elementType: "geometry", stylers: [{ color: "#1d2c4d" }] },
                        { elementType: "labels.text.fill", stylers: [{ color: "#8ec3b9" }] },
                        { elementType: "labels.text.stroke", stylers: [{ color: "#1a3646" }] },
                        { featureType: "administrative.country", elementType: "geometry.stroke", stylers: [{ color: "#4b6878" }] },
                        { featureType: "administrative.land_parcel", elementType: "labels.text.fill", stylers: [{ color: "#64779e" }] },
                        { featureType: "administrative.province", elementType: "geometry.stroke", stylers: [{ color: "#4b6878" }] },
                        { featureType: "landscape.man_made", elementType: "geometry.stroke", stylers: [{ color: "#334e87" }] },
                        { featureType: "landscape.natural", elementType: "geometry", stylers: [{ color: "#023e58" }] },
                        { featureType: "poi", elementType: "geometry", stylers: [{ color: "#283d6a" }] },
                        { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#6f9ba5" }] },
                        { featureType: "poi", elementType: "labels.text.stroke", stylers: [{ color: "#1d2c4d" }] },
                        { featureType: "poi.park", elementType: "geometry.fill", stylers: [{ color: "#023e58" }] },
                        { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#3C7680" }] },
                        { featureType: "road", elementType: "geometry", stylers: [{ color: "#304a7d" }] },
                        { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#98a5be" }] },
                        { featureType: "road", elementType: "labels.text.stroke", stylers: [{ color: "#1d2c4d" }] },
                        { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#2c6675" }] },
                        { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#255763" }] },
                        { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#b0d5ce" }] },
                        { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ color: "#023e58" }] },
                        { featureType: "transit", elementType: "labels.text.fill", stylers: [{ color: "#98a5be" }] },
                        { featureType: "transit", elementType: "labels.text.stroke", stylers: [{ color: "#1d2c4d" }] },
                        { featureType: "transit.line", elementType: "geometry.fill", stylers: [{ color: "#283d6a" }] },
                        { featureType: "transit.station", elementType: "geometry", stylers: [{ color: "#3a4762" }] },
                        { featureType: "water", elementType: "geometry", stylers: [{ color: "#0e1626" }] },
                        { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#4e6d70" }] },
                    ],
                },
            }),
                (_.apiStatus = null),
                (this.geolocate = function (a) {
                    var b = $.Deferred(),
                        c = new google.maps.Geocoder(),
                        d = a.data("address-setting");
                    return (
                        c.geocode({ address: d }, function (c, a) {
                            a !== google.maps.GeocoderStatus.OK && b.reject(a), b.resolve(c);
                        }),
                        b
                    );
                }),
                (this.createMap = function (a) {
                    var b = $(".map-section__map-container", a);
                    return _.geolocate(b)
                        .then(
                            function (c) {
                                var d = { zoom: _.config.zoom, styles: _.config.styles[$(a).data("map-style")], center: c[0].geometry.location, scrollwheel: !1, disableDoubleClickZoom: !0, disableDefaultUI: !0, zoomControl: !0 };
                                (_.map = new google.maps.Map(b[0], d)),
                                    (_.center = _.map.getCenter()),
                                    new google.maps.Marker({ map: _.map, position: _.center, clickable: !1 }),
                                    google.maps.event.addDomListener(window, "resize", function () {
                                        google.maps.event.trigger(_.map, "resize"), _.map.setCenter(_.center);
                                    });
                            }.bind(this)
                        )
                        .fail(function () {
                            var a;
                            switch (status) {
                                case "ZERO_RESULTS":
                                    a = theme.strings.addressNoResults;
                                    break;
                                case "OVER_QUERY_LIMIT":
                                    a = theme.strings.addressQueryLimit;
                                    break;
                                default:
                                    a = theme.strings.addressError;
                            }
                            if (Shopify.designMode) {
                                var c = b.parents(".map-section");
                                c.addClass("page-width map-section--load-error"), c.find(".map-section__wrapper").html('<div class="errors text-center">' + a + "</div>");
                            }
                        });
                }),
                (this.onSectionLoad = function (b) {
                    var c = $(b);
                    window.gm_authFailure = function () {
                        Shopify.designMode && (c.addClass("page-width map-section--load-error"), c.find(".map-section__wrapper").html('<div class="errors text-center">' + theme.strings.authError + "</div>"));
                    };
                    var a = c.data("api-key");
                    "string" == typeof a &&
                        "" !== a &&
                        theme.loadScriptOnce("https://maps.googleapis.com/maps/api/js?key=" + a, function () {
                            _.createMap(c);
                        });
                }),
                (this.onSectionUnload = function (a) {
                    void 0 !== window.google && void 0 !== google.maps && google.maps.event.clearListeners(this.map, "resize");
                });
        })()),
            a.sections.push({ name: "map", section: theme.MapSection }),
            (theme.VideoManager = new (function () {
                var _ = this;
                (_._permitPlayback = function (a) {
                    return !($(a).hasClass("video-container--background") && 768 > $(window).outerWidth());
                }),
                    (_.youtubeVars = { incrementor: 0, apiReady: !1, videoData: {}, toProcessSelector: '.video-container[data-video-type="youtube"]:not(.video--init)' }),
                    (_.youtubeApiReady = function () {
                        (_.youtubeVars.apiReady = !0), _._loadYoutubeVideos();
                    }),
                    (_._loadYoutubeVideos = function (a) {
                        $(_.youtubeVars.toProcessSelector, a).length &&
                            (_.youtubeVars.apiReady
                                ? $(_.youtubeVars.toProcessSelector, a).each(function () {
                                      if (_._permitPlayback($(this))) {
                                          $(this).addClass("video--init"), _.youtubeVars.incrementor++;
                                          var a = "theme-yt-video-" + _.youtubeVars.incrementor;
                                          $(this).data("video-container-id", a);
                                          var d = $('<div class="video-container__video-element">').attr("id", a).appendTo($(".video-container__video", this)),
                                              c = $(this).data("video-autoplay"),
                                              b = $(this).data("video-loop"),
                                              e = new YT.Player(a, {
                                                  height: "360",
                                                  width: "640",
                                                  videoId: $(this).data("video-id"),
                                                  playerVars: { iv_load_policy: 3, modestbranding: 1, autoplay: 0, loop: b ? 1 : 0, playlist: $(this).data("video-id"), rel: 0, showinfo: 0 },
                                                  events: {
                                                      onReady: _._onYoutubePlayerReady.bind({ autoplay: c, loop: b, $container: $(this) }),
                                                      onStateChange: _._onYoutubePlayerStateChange.bind({ autoplay: c, loop: b, $container: $(this) }),
                                                  },
                                              });
                                          _.youtubeVars.videoData[a] = { id: a, container: this, videoElement: d, player: e };
                                      }
                                  })
                                : theme.loadScriptOnce("https://www.youtube.com/iframe_api"));
                    }),
                    (_._onYoutubePlayerReady = function (a) {
                        a.target.setPlaybackQuality("hd1080"), this.autoplay && (a.target.mute(), a.target.playVideo()), _._initBackgroundVideo(this.$container);
                    }),
                    (_._onYoutubePlayerStateChange = function (a) {
                        if (a.data == YT.PlayerState.PLAYING && (this.$container.addClass("video--play-started"), this.autoplay && a.target.mute(), this.loop)) {
                            var b = a.target.getDuration() - 1;
                            b > 2 && (a.target.getCurrentTime() > b && a.target.seekTo(0), setTimeout(loopTheVideo, 250));
                        }
                    }),
                    (_._unloadYoutubeVideos = function (c) {
                        for (var a in _.youtubeVars.videoData) {
                            var b = _.youtubeVars.videoData[a];
                            if ($(c).find(b.container).length) {
                                b.player.destroy(), delete _.youtubeVars.videoData[a];
                                return;
                            }
                        }
                    }),
                    (_.vimeoVars = { incrementor: 0, apiReady: !1, videoData: {}, toProcessSelector: '.video-container[data-video-type="vimeo"]:not(.video--init)' }),
                    (_.vimeoApiReady = function () {
                        (_.vimeoVars.apiReady = !0), _._loadVimeoVideos();
                    }),
                    (_._loadVimeoVideos = function (a) {
                        $(_.vimeoVars.toProcessSelector, a).length &&
                            (_.vimeoVars.apiReady
                                ? $(_.vimeoVars.toProcessSelector, a).each(function () {
                                      if (_._permitPlayback($(this))) {
                                          $(this).addClass("video--init"), _.vimeoVars.incrementor++;
                                          var d = $(this),
                                              a = "theme-vi-video-" + _.vimeoVars.incrementor;
                                          $(this).data("video-container-id", a);
                                          var e = $('<div class="video-container__video-element">').attr("id", a).appendTo($(".video-container__video", this)),
                                              c = !!$(this).data("video-autoplay"),
                                              b = new Vimeo.Player(a, { url: $(this).data("video-url"), width: 640, loop: $(this).data("video-autoplay"), autoplay: c, muted: d.hasClass("video-container--background") });
                                          b.on(
                                              "playing",
                                              function () {
                                                  $(this).addClass("video--play-started");
                                              }.bind(this)
                                          ),
                                              b.ready().then(function () {
                                                  if ((c && (b.setVolume(0), b.play()), b.element && b.element.width && b.element.height)) {
                                                      var a = parseInt(b.element.height) / parseInt(b.element.width);
                                                      d.find(".video-container__video").css("padding-bottom", 100 * a + "%");
                                                  }
                                                  _._initBackgroundVideo(d);
                                              }),
                                              (_.vimeoVars.videoData[a] = { id: a, container: this, videoElement: e, player: b, autoPlay: c });
                                      }
                                  })
                                : window.define
                                ? theme.loadScriptOnce(
                                      "https://player.vimeo.com/api/player.js",
                                      function () {
                                          (_.vimeoVars.apiReady = !0), _._loadVimeoVideos(), (window.define = window.tempDefine);
                                      },
                                      function () {
                                          (window.tempDefine = window.define), (window.define = null);
                                      }
                                  )
                                : theme.loadScriptOnce("https://player.vimeo.com/api/player.js", function () {
                                      (_.vimeoVars.apiReady = !0), _._loadVimeoVideos();
                                  }));
                    }),
                    (_._unloadVimeoVideos = function (c) {
                        for (var a in _.vimeoVars.videoData) {
                            var b = _.vimeoVars.videoData[a];
                            if ($(c).find(b.container).length) {
                                b.player.unload(), delete _.vimeoVars.videoData[a];
                                return;
                            }
                        }
                    }),
                    (_._loadThirdPartyApis = function (a) {
                        _._permitPlayback($(".video-container", a)) && (_._loadYoutubeVideos(a), _._loadVimeoVideos(a));
                    }),
                    (_.mp4Vars = { incrementor: 0, videoData: {}, toProcessSelector: '.video-container[data-video-type="mp4"]:not(.video--init)' }),
                    (_._loadMp4Videos = function (a) {
                        $(_.mp4Vars.toProcessSelector, a).length &&
                            $(_.mp4Vars.toProcessSelector, a)
                                .addClass("video--init")
                                .each(function () {
                                    _.mp4Vars.incrementor++, $(this);
                                    var b = "theme-mp-video-" + _.mp4Vars.incrementor;
                                    $(this).data("video-container-id", b);
                                    var c = $('<div class="video-container__video-element">').attr("id", b).appendTo($(".video-container__video", this)),
                                        a = $("<video playsinline>");
                                    $(this).data("video-loop") && a.attr("loop", "loop"),
                                        $(this).data("video-autoplay") &&
                                            (a.attr({ autoplay: "autoplay", muted: "muted" }),
                                            (a[0].muted = !0),
                                            a.one("loadeddata", function () {
                                                this.play();
                                            })),
                                        a.on(
                                            "playing",
                                            function () {
                                                $(this).addClass("video--play-started");
                                            }.bind(this)
                                        ),
                                        a.attr("src", $(this).data("video-url")).appendTo(c);
                                });
                    }),
                    (_._unloadMp4Videos = function (a) {}),
                    (_._initBackgroundVideo = function (a) {
                        if (a.hasClass("video-container--background") && a.find(".video-container__video iframe").length) {
                            var b = function () {
                                var e = this,
                                    b = e.width(),
                                    d = e.height(),
                                    j = b / d,
                                    f = $(".video-container__video iframe", this),
                                    c = f.attr("width") / f.attr("height"),
                                    g = $(".video-container__video", this),
                                    a = 75;
                                if (j > c) {
                                    var h = b / c + 2 * a;
                                    g.css({ marginTop: (d - h) / 2 - a, marginLeft: "", height: h + 2 * a, width: "" });
                                } else {
                                    var i = b * c + 2 * a * c;
                                    g.css({ marginTop: -a, marginLeft: (b - i) / 2, height: d + 2 * a, width: i });
                                }
                            };
                            b.bind(a)(), $(window).on("debouncedresize." + a.data("video-container-id"), b.bind(a));
                        }
                    }),
                    (this.onSectionLoad = function (a) {
                        $(".video-container[data-video-url]:not([data-video-type])").each(function () {
                            var a = $(this).data("video-url");
                            a.indexOf(".mp4") > -1 && $(this).attr("data-video-type", "mp4"),
                                a.indexOf("vimeo.com") > -1 && ($(this).attr("data-video-type", "vimeo"), $(this).attr("data-video-id", a.split("?")[0].split("/").pop())),
                                (a.indexOf("youtu.be") > -1 || a.indexOf("youtube.com") > -1) &&
                                    ($(this).attr("data-video-type", "youtube"), a.indexOf("v=") > -1 ? $(this).attr("data-video-id", a.split("v=").pop().split("&")[0]) : $(this).attr("data-video-id", a.split("?")[0].split("/").pop()));
                        }),
                            _._loadThirdPartyApis(a),
                            _._loadMp4Videos(a),
                            $(window).on("debouncedresize.video-manager-resize", function () {
                                _._loadThirdPartyApis(a);
                            }),
                            $(".video-container__play", a).on("click", function (d) {
                                d.preventDefault();
                                var c = $(this).closest(".video-container");
                                c.addClass("video-container--playing"), $(a).trigger("cc:video:play");
                                var b = c.data("video-container-id");
                                0 === b.indexOf("theme-yt-video") ? _.youtubeVars.videoData[b].player.playVideo() : _.vimeoVars.videoData[b].player.play();
                            }),
                            $(".video-container__stop", a).on("click", function (d) {
                                d.preventDefault();
                                var c = $(this).closest(".video-container");
                                c.removeClass("video-container--playing"), $(a).trigger("cc:video:stop");
                                var b = c.data("video-container-id");
                                0 === b.indexOf("theme-yt-video") ? _.youtubeVars.videoData[b].player.stopVideo() : (_.vimeoVars.videoData[b].player.pause(), _.vimeoVars.videoData[b].player.setCurrentTime(0));
                            });
                    }),
                    (this.onSectionUnload = function (a) {
                        $(".video-container__play, .video-container__stop", a).off("click"),
                            $(window).off("." + $(".video-container").data("video-container-id")),
                            $(window).off("debouncedresize.video-manager-resize"),
                            _._unloadYoutubeVideos(a),
                            _._unloadVimeoVideos(a),
                            _._unloadMp4Videos(a),
                            $(a).trigger("cc:video:stop");
                    });
            })()),
            (window.onYouTubeIframeAPIReady = function () {
                theme.VideoManager.youtubeApiReady();
            }),
            a.sections.push({ name: "video", section: theme.VideoManager }),
            (theme.Popup = new (function () {
                var a = "cc-theme-popup-dismissed";
                (this.onSectionLoad = function (c) {
                    var i = this;
                    (this.namespace = theme.namespaceFromSection(c)), (this.$container = $(c)), (this.popup = new g(this.$container, this.namespace));
                    var f = this.$container.data("dismiss-for-days"),
                        d = this.$container.data("delay-seconds"),
                        b = !0,
                        h = this.$container.data("test-mode"),
                        e = window.localStorage.getItem(a);
                    e && (new Date().getTime() - e) / 864e5 < f && (b = !1),
                        this.$container.find(".cc-popup-form__response").length && ((b = !0), (d = 1), this.$container.find(".cc-popup-form__response--success").length && this.functions.popupSetAsDismissed.call(this)),
                        document.querySelector(".shopify-challenge__container") && (b = !1),
                        (b || h) &&
                            setTimeout(function () {
                                i.popup.open();
                            }, 1e3 * d),
                        this.$container.on("click" + this.namespace, ".cc-popup-close, .cc-popup-background", function () {
                            i.popup.close(function () {
                                i.functions.popupSetAsDismissed.call(i);
                            });
                        });
                }),
                    (this.onSectionSelect = function () {
                        this.popup.open();
                    }),
                    (this.functions = {
                        popupSetAsDismissed: function () {
                            window.localStorage.setItem(a, new Date().getTime());
                        },
                    }),
                    (this.onSectionUnload = function () {
                        this.$container.off(this.namespace);
                    });
            })()),
            a.sections.push({ name: "newsletter-popup", section: theme.Popup }),
            (theme.StoreAvailability = function (a) {
                var b = "store-availability-loading",
                    c = "store-availability-initialized",
                    d = "cc-location";
                (this.onSectionLoad = function (a) {
                    var c = this;
                    (this.namespace = theme.namespaceFromSection(a)), (this.$container = $(a)), (this.productId = this.$container.data("store-availability-container")), (this.sectionUrl = this.$container.data("section-url")), this.$modal;
                    var b = !0;
                    $(window).on("cc-variant-updated".concat(this.namespace).concat(this.productId), function (d, a) {
                        a.product.id === c.productId && (c.functions.updateContent.bind(c)(a.variant.id, a.product.title, b, c.$container.data("has-only-default-variant"), void 0 !== a.variant.available), (b = !1));
                    }),
                        this.$container.data("single-variant-id") &&
                            (this.functions.updateContent.bind(this)(
                                this.$container.data("single-variant-id"),
                                this.$container.data("single-variant-product-title"),
                                b,
                                this.$container.data("has-only-default-variant"),
                                this.$container.data("single-variant-product-available")
                            ),
                            (b = !1));
                }),
                    (this.onSectionUnload = function () {
                        $(window).off("cc-variant-updated".concat(this.namespace).concat(this.productId)), this.$container.off("click"), this.$modal && this.$modal.off("click");
                    }),
                    (this.functions = {
                        getUserLocation: function () {
                            return new Promise(function (b, c) {
                                var a;
                                sessionStorage[d] && (a = JSON.parse(sessionStorage[d])),
                                    a
                                        ? b(a)
                                        : navigator.geolocation
                                        ? navigator.geolocation.getCurrentPosition(
                                              function (c) {
                                                  var a = { latitude: c.coords.latitude, longitude: c.coords.longitude };
                                                  fetch("/localization.json", { method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify(a) }), (sessionStorage[d] = JSON.stringify(a)), b(a);
                                              },
                                              function () {
                                                  b(!1);
                                              },
                                              { maximumAge: 36e5, timeout: 5e3 }
                                          )
                                        : b(!1);
                            });
                        },
                        getAvailableStores: function (a, b) {
                            return $.get(this.sectionUrl.replace("VARIANT_ID", a), b);
                        },
                        calculateDistance: function (b, c, g) {
                            var a = Math.PI / 180,
                                d = b.latitude * a,
                                h = b.longitude * a,
                                e = c.latitude * a,
                                f = Math.pow(Math.sin((d - e) / 2), 2) + Math.cos(d) * Math.cos(e) * Math.pow(Math.sin((h - c.longitude * a) / 2), 2);
                            return ("metric" === g ? 6378.14 : 3959) * (2 * Math.atan2(Math.sqrt(f), Math.sqrt(1 - f)));
                        },
                        updateLocationDistances: function (a) {
                            var b = this.$modal.find("[data-unit-system]").data("unit-system"),
                                c = this;
                            this.$modal.find('[data-distance="false"]').each(function () {
                                var f = this,
                                    d = { latitude: parseFloat($(this).data("latitude")), longitude: parseFloat($(this).data("longitude")) };
                                if (d.latitude && d.longitude) {
                                    var e = c.functions.calculateDistance(a, d, b).toFixed(1);
                                    $(this).html(e),
                                        setTimeout(function () {
                                            $(f).closest(".store-availability-list__location__distance").addClass("-in");
                                        }, 0);
                                }
                                $(this).attr("data-distance", "true");
                            });
                        },
                        updateContent: function (d, f, e, h, a) {
                            var i = this;
                            this.$container.off("click", "[data-store-availability-modal-open]"),
                                this.$container.off("click" + this.namespace, ".cc-popup-close, .cc-popup-background"),
                                $(".store-availabilities-modal").remove(),
                                e
                                    ? this.$container.hide()
                                    : a
                                    ? (this.$container.addClass(b).addClass(c), this.$container.css("height", this.$container.outerHeight() > 0 ? this.$container.outerHeight() + "px" : "auto"))
                                    : (this.$container.addClass(b).addClass(c), this.$container.css("height", "0px")),
                                a &&
                                    this.functions.getAvailableStores.call(this, d, function (a) {
                                        if (a.trim().length > 0 && !a.includes("NO_PICKUP")) {
                                            i.$container.html(a),
                                                i.$container.html(i.$container.children().first().html()),
                                                i.$container.find("[data-store-availability-modal-product-title]").html(f),
                                                h && i.$container.find(".store-availabilities-modal__variant-title").remove(),
                                                i.$container.find(".cc-popup").appendTo("body"),
                                                (i.$modal = $("body").find(".store-availabilities-modal"));
                                            var j = new g(i.$modal, i.namespace);
                                            if (
                                                (i.$container.on("click", "[data-store-availability-modal-open]", function () {
                                                    return (
                                                        j.open(),
                                                        i.functions.getUserLocation().then(function (a) {
                                                            a &&
                                                                i.$modal.find('[data-distance="false"]').length &&
                                                                i.functions.getAvailableStores.call(i, d, function (b) {
                                                                    i.$modal.find(".store-availabilities-list").html($(b).find(".store-availabilities-list").html()), i.functions.updateLocationDistances.bind(i)(a);
                                                                });
                                                        }),
                                                        !1
                                                    );
                                                }),
                                                i.$modal.on("click" + i.namespace, ".cc-popup-close, .cc-popup-background", function () {
                                                    j.close();
                                                }),
                                                e)
                                            )
                                                i.$container.slideDown(300);
                                            else {
                                                i.$container.removeClass(b);
                                                var c = i.$container.find(".store-availability-container").outerHeight();
                                                i.$container.css("height", c > 0 ? c + "px" : "auto");
                                            }
                                        }
                                    });
                        },
                    }),
                    this.onSectionLoad(a);
            }),
            a.sections.push({ name: "store-availability", section: theme.StoreAvailability }),
            (theme.icons = {
                check:
                    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>',
                chevronRight:
                    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg>',
                arrowLeft:
                    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>',
                slideshowPrevArrow:
                    '<button class="slick-prev"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
                    theme.strings.previous +
                    '</title><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg></button>',
                slideshowNextArrow:
                    '<button class="slick-next"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
                    theme.strings.next +
                    '</title><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg></button>',
            }),
            (slate.a11y = {
                pageLinkFocus: function (a) {
                    var b = "js-focus-hidden";
                    a.first()
                        .attr("tabIndex", "-1")
                        .focus()
                        .addClass(b)
                        .one("blur", function () {
                            a.first().removeClass(b).removeAttr("tabindex");
                        });
                },
                focusHash: function () {
                    var a = window.location.hash;
                    a && document.getElementById(a.slice(1)) && this.pageLinkFocus($(a));
                },
                bindInPageLinks: function () {
                    $("a[href*=#]").on(
                        "click",
                        function (a) {
                            this.pageLinkFocus($(a.currentTarget.hash));
                        }.bind(this)
                    );
                },
                trapFocus: function (a) {
                    var b = a.namespace ? "focusin." + a.namespace : "focusin";
                    a.$elementToFocus || (a.$elementToFocus = a.$container),
                        a.$container.attr("tabindex", "-1"),
                        a.$elementToFocus.focus(),
                        $(document).on(b, function (b) {
                            a.$container[0] === b.target || a.$container.has(b.target).length || a.$container.focus();
                        });
                },
                removeTrapFocus: function (a) {
                    var b = a.namespace ? "focusin." + a.namespace : "focusin";
                    a.$container && a.$container.length && a.$container.removeAttr("tabindex"), $(document).off(b);
                },
            }),
            (slate.cart = {
                cookiesEnabled: function () {
                    var a = navigator.cookieEnabled;
                    return a || ((document.cookie = "testcookie"), (a = -1 !== document.cookie.indexOf("testcookie"))), a;
                },
            }),
            (slate.utils = {
                findInstance: function (b, c, d) {
                    for (var a = 0; a < b.length; a++) if (b[a][c] === d) return b[a];
                },
                removeInstance: function (a, c, d) {
                    for (var b = a.length; b--; )
                        if (a[b][c] === d) {
                            a.splice(b, 1);
                            break;
                        }
                    return a;
                },
                compact: function (a) {
                    for (var b = -1, e = null == a ? 0 : a.length, f = 0, c = []; ++b < e; ) {
                        var d = a[b];
                        d && (c[f++] = d);
                    }
                    return c;
                },
                defaultTo: function (a, b) {
                    return null == a || a != a ? b : a;
                },
            }),
            (slate.rte = {
                wrapTable: function (a) {
                    var b = void 0 === a.tableWrapperClass ? "" : a.tableWrapperClass;
                    a.$tables.wrap('<div class="' + b + '"></div>');
                },
                wrapIframe: function (a) {
                    var b = void 0 === a.iframeWrapperClass ? "" : a.iframeWrapperClass;
                    a.$iframes.each(function () {
                        $(this).wrap('<div class="' + b + '"></div>'), (this.src = this.src);
                    });
                },
            }),
            (slate.Image = {
                preload: function (a, c) {
                    "string" == typeof a && (a = [a]);
                    for (var b = 0; b < a.length; b++) {
                        var d = a[b];
                        this.loadImage(this.getSizedImageUrl(d, c));
                    }
                },
                loadImage: function (a) {
                    new Image().src = a;
                },
                imageSize: function (b) {
                    var a = b.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
                    return a ? a[1] : null;
                },
                getSizedImageUrl: function (a, b) {
                    if (null === b) return a;
                    if ("master" === b) return this.removeProtocol(a);
                    var c = a.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                    if (!c) return null;
                    var d = a.split(c[0]),
                        e = c[0];
                    return this.removeProtocol(d[0] + "_" + b + e);
                },
                removeProtocol: function (a) {
                    return a.replace(/http(s)?:/, "");
                },
            }),
            (slate.Variants = (function () {
                function a(a) {
                    (this.$container = a.$container),
                        (this.product = a.product),
                        (this.singleOptionSelector = a.singleOptionSelector),
                        (this.originalSelectorId = a.originalSelectorId),
                        (this.enableHistoryState = a.enableHistoryState),
                        (this.currentVariant = this._getVariantFromOptions()),
                        $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this));
                }
                return (
                    (a.prototype = $.extend({}, a.prototype, {
                        _getCurrentOptions: function () {
                            var a = $.map($(this.singleOptionSelector, this.$container), function (d) {
                                var a = $(d),
                                    c = a.attr("type"),
                                    b = {};
                                return "radio" !== c && "checkbox" !== c ? ((b.value = a.val()), (b.index = a.data("index")), b) : !!a[0].checked && ((b.value = a.val()), (b.index = a.data("index")), b);
                            });
                            return slate.utils.compact(a);
                        },
                        _getVariantFromOptions: function () {
                            var c = this._getCurrentOptions(),
                                a = this.product.variants,
                                b = !1;
                            return (
                                a.forEach(function (a) {
                                    var d = !0;
                                    c.forEach(function (b) {
                                        d && (d = b.value === a[b.index]);
                                    }),
                                        d && (b = a);
                                }),
                                b || null
                            );
                        },
                        _onSelectChange: function () {
                            var a = this._getVariantFromOptions();
                            this.$container.trigger({ type: "variantChange", variant: a }),
                                a &&
                                    ($(window).trigger("cc-variant-updated", { variant: a, product: this.product }),
                                    this._updateMasterSelect(a),
                                    this._updateImages(a),
                                    this._updatePrice(a),
                                    (this.currentVariant = a),
                                    this.enableHistoryState && this._updateHistoryState(a));
                        },
                        _updateImages: function (a) {
                            var b = a.featured_media || {},
                                c = this.currentVariant.featured_media || {};
                            a.featured_media && b.id !== c.id && this.$container.trigger({ type: "variantImageChange", variant: a });
                        },
                        _updatePrice: function (a) {
                            var b = !1;
                            if (
                                ((a.price !== this.currentVariant.price ||
                                    a.compare_at_price !== this.currentVariant.compare_at_price ||
                                    a.unit_price_measurement !== this.currentVariant.unit_price_measurement ||
                                    (a.unit_price_measurement &&
                                        (a.unit_price !== this.currentVariant.unit_price ||
                                            a.unit_price_measurement.reference_value !== this.currentVariant.unit_price_measurement.reference_value ||
                                            a.unit_price_measurement.reference_unit !== this.currentVariant.unit_price_measurement.reference_unit))) &&
                                    (b = !0),
                                b)
                            ) {
                                this.$container.trigger({ type: "variantPriceChange", variant: a });
                                var c = this.$container[0].querySelector('input[name="id"]');
                                (c.value = a.id), c.dispatchEvent(new Event("change", { bubbles: !0 }));
                            }
                        },
                        _updateHistoryState: function (a) {
                            if (history.replaceState && a) {
                                var b = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + a.id;
                                window.history.replaceState({ path: b }, "", b);
                            }
                        },
                        _updateMasterSelect: function (b) {
                            var a = $(this.originalSelectorId, this.$container)[0];
                            a && ((a.value = b.id), a.dispatchEvent(new Event("change", { bubbles: !0, cancelable: !1 })));
                        },
                    })),
                    a
                );
            })()),
            (theme.addNoticeToForm = function (b, a) {
                var c = $(".ajax-add-notice", a);
                c.length > 0
                    ? setTimeout(function () {
                          c.replaceWith(b.addClass("ajax-add-notice--pre-replace")),
                              setTimeout(function () {
                                  b.removeClass("ajax-add-notice--pre-replace");
                              }, 10);
                      }, 251)
                    : b
                          .addClass("ajax-add-notice--pre-reveal")
                          .appendTo(a)
                          .slideDown(250, function () {
                              $(this).removeClass("ajax-add-notice--pre-reveal");
                          });
            }),
            $(document).on("submit", 'form.product-form[data-ajax-add="true"]', function (b) {
                var a = $(this);
                if (document.body.classList.contains("template-cart")) {
                    a.attr("data-ajax-add", !1), a.submit();
                    return;
                }
                return (
                    a
                        .find(":submit")
                        .attr("disabled", "disabled")
                        .each(function () {
                            var a = $(this).is("button") ? "html" : "val";
                            $(this).data("previous-value", $(this)[a]())[a](theme.strings.addingToCart);
                        }),
                    $(".ajax-add-notice", a).css("opacity", 0),
                    $.post(
                        theme.routes.cart_add_url + ".js",
                        a.serialize(),
                        function (c) {
                            a
                                .find(":submit")
                                .each(function () {
                                    var a = $(this),
                                        b = $(this).is("button") ? "html" : "val";
                                    a.removeAttr("disabled")[b](a.data("previous-value"));
                                })
                                .first(),
                                $.get(theme.routes.search_url, function (d) {
                                    for (var b = [".page-header .cart"], e = $($.parseHTML("<div>" + d + "</div>")), a = 0; a < b.length; a++) {
                                        var c = b[a],
                                            f = e.find(c).clone();
                                        $(c).replaceWith(f);
                                    }
                                });
                            var b = $(
                                [
                                    '<div class="ajax-add-notice ajax-add-notice--added global-border-radius">',
                                    '<div class="ajax-add-notice__inner">',
                                    '<div class="ajax-add-notice__item">',
                                    '<span class="feather-icon">',
                                    theme.icons.check,
                                    "</span>",
                                    theme.strings.addedToCart,
                                    "</div>",
                                    '<div class="ajax-add-notice__go">',
                                    '<a href="',
                                    theme.routes.cart_url,
                                    '">',
                                    theme.strings.goToCart,
                                    '<span class="feather-icon feather-icon--small">',
                                    theme.icons.chevronRight,
                                    "</span>",
                                    "</a>",
                                    "</div>",
                                    "</div>",
                                    "</div>",
                                ].join("")
                            );
                            theme.addNoticeToForm(b, a);
                        },
                        "json"
                    ).fail(function (b) {
                        if (
                            (a
                                .find(":submit")
                                .removeAttr("disabled")
                                .each(function () {
                                    var a = $(this),
                                        b = a.is("button") ? "html" : "val";
                                    a[b](a.data("previous-value"));
                                })
                                .first(),
                            void 0 !== b && void 0 !== b.status)
                        ) {
                            var c = $.parseJSON(b.responseText),
                                d = $(['<div class="ajax-add-notice ajax-add-notice--error global-border-radius">', '<div class="ajax-add-notice__inner">', c.description, "</div>", "</div>"].join(""));
                            theme.addNoticeToForm(d, a);
                        } else a.attr("data-ajax-add", !1), a.submit();
                    }),
                    !1
                );
            }),
            (theme.ProductMedia = new (function () {
                var _ = this;
                (_._setupShopifyXr = function () {
                    if (!window.ShopifyXR) {
                        document.addEventListener("shopify_xr_initialized", _._setupShopifyXr.bind(this));
                        return;
                    }
                    document.removeEventListener("shopify_xr_initialized", _._setupShopifyXr), window.ShopifyXR.addModels(JSON.parse($(this).html())), window.ShopifyXR.setupXRElements();
                }),
                    (this.init = function (a, b) {
                        var b = b || {},
                            c = a;
                        $(a).on("mediaVisible", ".product-media--video-loaded, .product-media--model-loaded", function () {
                            $(window).width() >= 768 && $(this).data("player").play(), $(this).hasClass("product-media--model") && $(".view-in-space", c).attr("data-shopify-model3d-id", $(this).data("model-id"));
                        }),
                            $(a).on("mediaHidden", ".product-media--video-loaded, .product-media--model-loaded", function () {
                                $(this).data("player").pause();
                            }),
                            b.onVideoVisible && $(a).on("mediaVisible", ".product-media--video-loaded", b.onVideoVisible),
                            b.onVideoHidden && $(a).on("mediaHidden", ".product-media--video-loaded", b.onVideoHidden),
                            $("model-viewer", a).each(function () {
                                b.onModelViewerPlay && $(this).on("shopify_model_viewer_ui_toggle_play", b.onModelViewerPlay), b.onModelViewerPause && $(this).on("shopify_model_viewer_ui_toggle_pause", b.onModelViewerPause);
                            });
                        var d = $(a).find(".product-media:first"),
                            e = function (a) {
                                return d[0] == a[0] && b.autoplayFirstMedia;
                            };
                        $(a)
                            .find(".product-media--video")
                            .each(function (d) {
                                var f = $(this).data("enable-video-looping"),
                                    a = $(this).find("iframe, video")[0],
                                    g = $(this);
                                if ("VIDEO" === a.tagName)
                                    window.Shopify.loadFeatures([
                                        {
                                            name: "video-ui",
                                            version: "1.0",
                                            onLoad: function () {
                                                var c = { playerType: "html5", element: a };
                                                (c.play = function () {
                                                    this.plyr.play();
                                                }.bind(c)),
                                                    (c.pause = function () {
                                                        this.plyr.pause();
                                                    }.bind(c)),
                                                    (c.destroy = function () {
                                                        this.plyr.destroy();
                                                    }.bind(c)),
                                                    (c.plyr = new Shopify.Plyr(a, {
                                                        controls: ["play", "progress", "mute", "volume", "play-large", "fullscreen"],
                                                        autoplay: e(g),
                                                        loop: { active: f },
                                                        hideControlsOnPause: !0,
                                                        iconUrl: "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg",
                                                        tooltips: { controls: !1, seek: !0 },
                                                    })),
                                                    $(this).data("player", c).addClass("product-media--video-loaded"),
                                                    $(a).on("playing", function () {
                                                        $(".product-media").not(g).trigger("mediaHidden"),
                                                            g
                                                                .find(".plyr__controls")
                                                                .off(".themeMediaEventFix")
                                                                .on("keydown.themeMediaEventFix touchstart.themeMediaEventFix mousedown.themeMediaEventFix", function (a) {
                                                                    a.stopPropagation();
                                                                }),
                                                            "undefined" != typeof callbacks && callbacks.onPlyrPlay && callbacks.onPlyrPlay(c);
                                                    }),
                                                    $(a).on("pause ended", function () {
                                                        g.find(".plyr__controls").off(".themeMediaEventFix"), "undefined" != typeof callbacks && callbacks.onPlyrPause && callbacks.onPlyrPause(c);
                                                    }),
                                                    b.onPlyrInit && b.onPlyrInit(c);
                                            }.bind(this),
                                        },
                                    ]),
                                        theme.loadStyleOnce("https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css");
                                else if ("IFRAME" === a.tagName && /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(a.src)) {
                                    var h = window.onYouTubeIframeAPIReady,
                                        c = function () {
                                            var c = { playerType: "youtube", element: a },
                                                d = $(this).data("video-id");
                                            (c.player = new YT.Player(a, {
                                                videoId: d,
                                                playerVars: { autoplay: e(g) ? 1 : 0, origin: window.location.origin },
                                                events: {
                                                    onReady: function (a) {
                                                        e(g) && a.target.playVideo();
                                                    },
                                                    onStateChange: function (a) {
                                                        a.data === YT.PlayerState.ENDED && f && a.target.seekTo(0);
                                                    },
                                                },
                                            })),
                                                (c.play = function () {
                                                    try {
                                                        this.player.playVideo();
                                                    } catch (a) {}
                                                }.bind(c)),
                                                (c.pause = function () {
                                                    try {
                                                        this.player.pauseVideo();
                                                    } catch (a) {}
                                                }.bind(c)),
                                                (c.destroy = function () {
                                                    try {
                                                        var a = $(this.element)[0].outerHTML,
                                                            b = $(this.element).parent();
                                                        this.player.destroy(), b.append(a);
                                                    } catch (c) {}
                                                }.bind(c)),
                                                $(this).data("player", c).addClass("product-media--video-loaded"),
                                                b.onYouTubeInit && b.onYouTubeInit(c);
                                        }.bind(this);
                                    window.YT && window.YT.Player
                                        ? c()
                                        : ((window.onYouTubeIframeAPIReady = function () {
                                              h && h(), c();
                                          }),
                                          theme.loadScriptOnce("https://www.youtube.com/iframe_api"));
                                }
                            }),
                            $(a).on("mediaVisible mediaVisibleInitial", ".product-media--model:not(.product-media--model-loaded):not(.product-media--model-loading)", function (a) {
                                var c = $(this).find("model-viewer")[0],
                                    d = "mediaVisibleInitial" != a.type || e($(this));
                                $(this).addClass("product-media--model-loading"),
                                    theme.loadStyleOnce("https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"),
                                    window.Shopify.loadFeatures([
                                        {
                                            name: "model-viewer-ui",
                                            version: "1.0",
                                            onLoad: function () {
                                                $(this).data("player", new Shopify.ModelViewerUI(c)),
                                                    $('<div class="theme-event-proxy">')
                                                        .on("mouseup", function (a) {
                                                            a.stopPropagation(),
                                                                a.preventDefault(),
                                                                $(a.currentTarget)
                                                                    .closest(".product-media")[0]
                                                                    .dispatchEvent(new MouseEvent("mouseup", { bubbles: !0 }));
                                                        })
                                                        .appendTo($(this).find(".shopify-model-viewer-ui__controls-overlay")),
                                                    $(this)
                                                        .find("model-viewer")
                                                        .on("shopify_model_viewer_ui_toggle_play", function () {
                                                            $(this)
                                                                .closest(".product-media")
                                                                .on("touchstart.themeModelViewerFix mousedown.themeModelViewerFix", function (a) {
                                                                    a.stopPropagation();
                                                                });
                                                        })
                                                        .on("shopify_model_viewer_ui_toggle_pause", function () {
                                                            $(this).closest(".product-media").off(".themeModelViewerFix");
                                                        }),
                                                    $(this).addClass("product-media--model-loaded").removeClass("product-media--model-loading"),
                                                    b.onModelViewerInit && b.onModelViewerInit(c),
                                                    d && $(this).trigger("mediaVisible");
                                            }.bind(this),
                                        },
                                    ]);
                            }),
                            $(".model-json", a).length &&
                                (window.Shopify.loadFeatures([{ name: "shopify-xr", version: "1.0", onLoad: _._setupShopifyXr.bind($(".model-json", a)) }]),
                                $(document).on("shopify_xr_launch", function () {
                                    $(".product-media--video-loaded").each(function () {
                                        $(this).data("player").pause();
                                    });
                                })),
                            setTimeout(
                                function () {
                                    $(".product-media:first", this).filter(".product-media--model").trigger("mediaVisibleInitial");
                                }.bind(a),
                                50
                            );
                    }),
                    (this.destroy = function (a) {
                        $(document).off("shopify_xr_launch"),
                            $(a).off("mediaVisible mediaVisibleInitial mediaHidden"),
                            $(".product-media--video-loaded, .product-media--model-loaded", a)
                                .each(function () {
                                    $(this).data("player").destroy();
                                })
                                .removeClass("product-media--video-loaded product-media--model-loaded"),
                            $(".product-media--video video", a).off("playing pause ended"),
                            $("model-viewer", a).off("shopify_model_viewer_ui_toggle_play shopify_model_viewer_ui_toggle_pause"),
                            $(".product-media--model .theme-event-proxy").off("mouseup").remove();
                    });
            })()),
            (theme.Sidebar = new (function () {
                this.onSectionLoad = function (a) {
                    (this.$container = $(a)), (this.namespace = theme.namespaceFromSection(a)), (this.sidebarExists = !!$(".sidebar", a).length), $(".template-index").toggleClass("page-has-sidebar", this.sidebarExists);
                };
            })()),
            (theme.Product = new (function () {
                var a = {
                    addToCart: "[data-add-to-cart]",
                    addToCartText: "[data-add-to-cart-text]",
                    comparePrice: "[data-compare-price]",
                    comparePriceText: "[data-compare-text]",
                    originalSelectorId: "[data-product-select]",
                    priceWrapper: "[data-price-wrapper]",
                    productFeaturedMedia: "[data-product-featured-media]",
                    productFeaturedMediaWithGallery: "[data-product-featured-media]:not(.product-image--no-gallery) .product-image__link, .product-thumbnails.slick-slider .product-image__link",
                    productThumbnailForCarouselContainer: ".product-thumbnails--inline",
                    productThumbnailImage: ".product-thumbnails__link, .carousel-media .product-image__link",
                    productJson: "[data-product-json]",
                    productPrice: "[data-product-price]",
                    zoomValidThumbs: ".product-thumbnails--desktop .product-thumbnails__item-media-image [data-product-single-thumbnail]",
                    singleOptionSelector: "[data-single-option-selector]",
                    styledSelect: ".selector-wrapper select",
                    skuWrapper: ".product-sku",
                    sku: ".product-sku__value",
                    unitPrice: ".unit-price",
                    storeAvailability: "[data-store-availability-container]",
                    inventoryNotice: ".product-inventory-notice",
                    variantSelector: ".variant-selector",
                };
                (this.onSectionLoad = function (b) {
                    if (((this.$container = $(b)), $(a.storeAvailability, b).length && (this.storeAvailability = new theme.StoreAvailability($(a.storeAvailability, b)[0])), $(a.productJson, this.$container).html())) {
                        this.$container.attr("data-section-id"), (this.productSingleObject = JSON.parse($(a.productJson, this.$container).html()));
                        var c = {
                            $container: this.$container,
                            enableHistoryState: this.$container.data("enable-history-state") || !1,
                            singleOptionSelector: a.singleOptionSelector,
                            originalSelectorId: a.originalSelectorId,
                            product: this.productSingleObject,
                        };
                        (this.settings = {}),
                            (this.namespace = ".product"),
                            (this.variants = new slate.Variants(c)),
                            (this.$featuredImage = $(a.productFeaturedMedia, this.$container)),
                            (this.$zoomValidThumbs = $(a.zoomValidThumbs, this.$container)),
                            this.$container.on("variantChange" + this.namespace, this.functions.updateAddToCartState.bind(this)),
                            this.$container.on("variantPriceChange" + this.namespace, this.functions.updateProductPrices.bind(this)),
                            this.$container.find(a.skuWrapper) && this.$container.on("variantChange" + this.namespace, this.functions.updateSKU.bind(this)),
                            this.$container.find(a.inventoryNotice) && this.$container.on("variantChange" + this.namespace, this.functions.updateInventoryNotice.bind(this)),
                            this.$featuredImage.length > 0 && this.$container.on("variantImageChange" + this.namespace, this.functions.updateProductImage.bind(this)),
                            (this.$thumbnails = $(a.productThumbnailImage, b)),
                            this.$thumbnails.length > 0 && this.$container.on("click" + this.namespace + " pseudoclick" + this.namespace, a.productThumbnailImage, this.functions.selectThumbnailImage.bind(this)),
                            this.$container.on("click" + this.namespace, a.productFeaturedMediaWithGallery, this.functions.openGallery.bind(this)),
                            theme.ProductMedia.init(this.$container),
                            theme.styleVariantSelectors($(a.styledSelect, b), c.product),
                            this.variants.product.variants.length > 1 && $(window).trigger("cc-variant-updated", { variant: this.variants.currentVariant, product: this.productSingleObject }),
                            this.$thumbnails.length > 0 &&
                                ((this.$thumbnailForCarouselContainer = $(a.productThumbnailForCarouselContainer, b)),
                                this.functions.assessMobileCarousel.bind(this)(),
                                $(window).on("debouncedresize" + this.namespace, this.functions.assessMobileCarousel.bind(this)),
                                this.$thumbnails.find(".lazyload--manual").removeClass("lazyload--manual").addClass("lazyload")),
                            theme.initProductTitleAlignmentWatcher(this.$container, this.namespace);
                    }
                }),
                    (this.functions = {
                        assessMobileCarousel: function () {
                            this.$featuredImage.is(":visible")
                                ? this.$thumbnailForCarouselContainer.hasClass("slick-slider") &&
                                  (theme.ProductMedia.destroy(this.$container),
                                  this.$thumbnailForCarouselContainer.find(".carousel-media").remove(),
                                  this.$thumbnailForCarouselContainer.slick("unslick").off("afterChange"),
                                  this.$thumbnailForCarouselContainer.removeClass("slick-slider"),
                                  theme.ProductMedia.init(this.$container),
                                  this.$thumbnailForCarouselContainer.find(".product-media").trigger("mediaVisibleInitial"))
                                : this.$thumbnailForCarouselContainer.hasClass("slick-slider") ||
                                  (this.$thumbnailForCarouselContainer.addClass("slick-slider"),
                                  theme.ProductMedia.destroy(this.$container),
                                  this.$thumbnailForCarouselContainer.slick({
                                      autoplay: !1,
                                      fade: !1,
                                      infinite: !1,
                                      useTransform: !0,
                                      dots: !0,
                                      arrows: !0,
                                      prevArrow: theme.icons.slideshowPrevArrow,
                                      nextArrow: theme.icons.slideshowNextArrow,
                                      appendArrows: $(".slick-external-controls .slick-external-arrows", this.$container),
                                      appendDots: $(".slick-external-controls .slick-external-dots", this.$container),
                                      adaptiveHeight: !0,
                                      initialSlide: $(".product-thumbnails__item--active", this.$thumbnailForCarouselContainer).index() || 0,
                                  }),
                                  this.$thumbnailForCarouselContainer.find(".product-thumbnails__item").each(function () {
                                      $('<div class="carousel-media">').append($(this).find(".thumbnail-media-template").html()).prependTo(this);
                                  }),
                                  theme.ProductMedia.init(this.$container, {
                                      onPlyrPlay: function (a) {
                                          $(a.target)
                                              .closest(".product-media")
                                              .find(".plyr__controls")
                                              .off(".themeModelViewerFix")
                                              .on(
                                                  "touchstart.themeModelViewerFix touchmove.themeModelViewerFix touchend.themeModelViewerFix mousedown.themeModelViewerFix mousemove.themeModelViewerFix mouseup.themeModelViewerFix",
                                                  function (a) {
                                                      a.stopPropagation();
                                                  }
                                              );
                                      },
                                  }),
                                  this.$thumbnailForCarouselContainer.find(".product-media").trigger("mediaVisibleInitial"),
                                  this.$thumbnailForCarouselContainer.on("afterChange", function (d, a, b) {
                                      var c = $(".product-media", a.$slides[b]);
                                      $(".product-media").not(c).trigger("mediaHidden"), c.trigger("mediaVisible"), theme.productGallerySlideshowTabFix(a.$slides, b);
                                  }));
                        },
                        updateAddToCartState: function (d) {
                            var b = d.variant;
                            if (b) $(a.priceWrapper, this.$container).removeClass("product-price--unavailable");
                            else {
                                $(a.addToCart, this.$container).prop("disabled", !0), $(a.addToCartText, this.$container).html(theme.strings.unavailable), $(a.priceWrapper, this.$container).addClass("product-price--unavailable");
                                return;
                            }
                            b.available
                                ? ($(a.addToCart, this.$container).prop("disabled", !1), $(a.addToCartText, this.$container).html(theme.strings.addToCart))
                                : ($(a.addToCart, this.$container).prop("disabled", !0), $(a.addToCartText, this.$container).html(theme.strings.soldOut));
                            var c = $(".backorder", this.$container);
                            if (c.length) {
                                if (b && b.available) {
                                    var e = $(a.originalSelectorId + ' option[value="' + b.id + '"]', this.$container);
                                    b.inventory_management && "out" == e.data("stock") ? (c.find(".backorder__variant").html(this.productSingleObject.title + (b.title.indexOf("Default") >= 0 ? "" : " - " + b.title)), c.show()) : c.hide();
                                } else c.hide();
                            }
                        },
                        _getBaseUnit: function (a) {
                            return 1 === a.unit_price_measurement.reference_value ? a.unit_price_measurement.reference_unit : a.unit_price_measurement.reference_value + a.unit_price_measurement.reference_unit;
                        },
                        updateProductPrices: function (h) {
                            var b = h.variant,
                                d = $(a.comparePrice, this.$container),
                                g = d.add(a.comparePriceText, this.$container),
                                e = $(a.productPrice, this.$container),
                                f = $(a.unitPrice, this.$container);
                            if (
                                (e.html('<span class="theme-money">' + theme.Shopify.formatMoney(b.price, theme.moneyFormat) + "</span>"),
                                b.compare_at_price > b.price
                                    ? (d.html('<span class="theme-money">' + theme.Shopify.formatMoney(b.compare_at_price, theme.moneyFormat) + "</span>"), g.removeClass("hide"), e.addClass("product-price__reduced"))
                                    : (d.html(""), g.addClass("hide"), e.removeClass("product-price__reduced")),
                                b.unit_price_measurement)
                            ) {
                                var c = $('<div class="unit-price small-text">');
                                $('<span class="unit-price__price theme-money">').html(theme.Shopify.formatMoney(b.unit_price, theme.moneyFormat)).appendTo(c),
                                    $('<span class="unit-price__separator">').html(theme.strings.unitPriceSeparator).appendTo(c),
                                    $('<span class="unit-price__unit">').html(this.functions._getBaseUnit(b)).appendTo(c),
                                    f.length ? f.replaceWith(c) : $(a.priceWrapper, this.$container).append(c);
                            } else f.remove();
                        },
                        updateSKU: function (c) {
                            var b = c.variant;
                            b && b.sku
                                ? ($(a.skuWrapper, this.$container).removeClass("product-sku--empty"), $(a.sku, this.$container).html(b.sku))
                                : ($(a.skuWrapper, this.$container).addClass("product-sku--empty"), $(a.sku, this.$container).empty());
                        },
                        _getVariantOptionElement: function (b) {
                            return $(a.variantSelector, this.$container).find('option[value="' + b.id + '"]');
                        },
                        updateInventoryNotice: function (d) {
                            var b = d.variant;
                            if (b) {
                                var c = this.functions._getVariantOptionElement(b).data("inventory");
                                c
                                    ? $(a.inventoryNotice, this.$container).removeClass("product-inventory-notice--no-inventory").html(theme.strings.inventoryNotice.replace("[[ quantity ]]", c))
                                    : $(a.inventoryNotice, this.$container).addClass("product-inventory-notice--no-inventory").empty();
                            } else $(a.inventoryNotice, this.$container).addClass("product-inventory-notice--no-inventory").empty();
                        },
                        selectThumbnailImage: function (b) {
                            var a = $(b.currentTarget).parent();
                            if (!a.hasClass("product-thumbnails__item--active")) {
                                if (this.$thumbnailForCarouselContainer.hasClass("slick-slider")) {
                                    if (a.hasClass("carousel-media"));
                                    else {
                                        var c = a.find("[data-thumbnail-media-id]").data("thumbnail-media-id"),
                                            d = this.$thumbnailForCarouselContainer
                                                .find('[data-thumbnail-media-id="' + c + '"]')
                                                .closest(".slick-slide")
                                                .data("slick-index");
                                        this.$thumbnailForCarouselContainer.slick("slickGoTo", d), a.addClass("product-thumbnails__item--active").siblings(".product-thumbnails__item--active").removeClass("product-thumbnails__item--active");
                                    }
                                } else
                                    theme.ProductMedia.destroy(this.$container),
                                        this.$featuredImage.html($(b.currentTarget).find(".thumbnail-media-template").html()),
                                        theme.ProductMedia.init(this.$container, { autoplayFirstMedia: !0 }),
                                        a.addClass("product-thumbnails__item--active").siblings(".product-thumbnails__item--active").removeClass("product-thumbnails__item--active");
                            }
                            b.preventDefault();
                        },
                        updateProductImage: function (b) {
                            var a = b.variant;
                            a.featured_media && this.$container.find('[data-thumbnail-media-id="' + a.featured_media.id + '"]').trigger("pseudoclick");
                        },
                        openGallery: function (g) {
                            g.preventDefault();
                            var h = document.querySelectorAll(".pswp")[0],
                                a = [];
                            if (this.$zoomValidThumbs.length) {
                                var k = !this.$zoomValidThumbs.is(":visible");
                                this.$zoomValidThumbs.each(function () {
                                    var b,
                                        c = { src: $(this).attr("href"), w: $(this).data("image-w"), h: $(this).data("image-h") };
                                    (b = k ? $('.product-image__link[href="' + $(this).attr("href") + '"]:visible img')[0] : $(this).find("img")[0]) && void 0 !== b.currentSrc && (c.msrc = b.currentSrc), a.push(c);
                                });
                            } else {
                                var c = { src: this.$featuredImage.find("a").attr("href"), w: this.$featuredImage.data("image-w"), h: this.$featuredImage.data("image-h") },
                                    d = this.$featuredImage.find("img")[0];
                                void 0 !== d.currentSrc && (c.msrc = d.currentSrc), a.push(c);
                            }
                            var e = 0,
                                f = this.$container.find(".product-thumbnails__item--active:not(.slick-slide):visible .product-thumbnails__link, .product-thumbnails__item-media-image.slick-current:visible .product-thumbnails__link");
                            if (f.length) {
                                for (var i = f.attr("href"), b = 0; b < a.length; b++)
                                    if (a[b].src == i) {
                                        e = b;
                                        break;
                                    }
                            }
                            var j = {
                                index: e,
                                history: !1,
                                captionEl: !1,
                                shareEl: !1,
                                fullscreenEl: !1,
                                getThumbBoundsFn: function (e) {
                                    var b = !1,
                                        f = a[e].src;
                                    if (this.$featuredImage.find(".product-image__link:visible").attr("href") == f) b = this.$featuredImage.find(".product-image__link img")[0];
                                    else {
                                        var d = this.$container
                                            .find(".product-thumbnails__link, .product-image__link")
                                            .filter(function () {
                                                return $(this).attr("href") == f;
                                            })
                                            .filter(":visible");
                                        d.length && (b = d.find("img")[0]);
                                    }
                                    b || (b = this.$featuredImage.find("img")[0]);
                                    var g = window.pageYOffset || document.documentElement.scrollTop,
                                        c = b.getBoundingClientRect();
                                    return { x: c.left, y: c.top + g, w: c.width };
                                }.bind(this),
                            };
                            (this.imageGallery = new PhotoSwipe(h, PhotoSwipeUI_Default, a, j)),
                                this.imageGallery.init(),
                                this.imageGallery.listen(
                                    "destroy",
                                    function () {
                                        this.imageGallery = null;
                                    }.bind(this)
                                );
                        },
                    }),
                    (this.onSectionUnload = function (a) {
                        this.$container.off(this.namespace),
                            $(window).off(this.namespace),
                            this.imageGallery && this.imageGallery.close(),
                            this.$thumbnailForCarouselContainer && this.$thumbnailForCarouselContainer.filter(".slick-slider").slick("unslick").off("afterChange"),
                            this.storeAvailability && this.storeAvailability.onSectionUnload(),
                            theme.ProductMedia.destroy(this.$container);
                    });
            })()),
            (theme.Header = new (function () {
                (this.onSectionLoad = function (a) {
                    (this.$container = $(a)),
                        (this.namespace = theme.namespaceFromSection(a)),
                        (this.mobileMenuTransitionTime = 500),
                        (this.$searchBar = $(".search-bar", a)),
                        (this.$newsletterSignupButton = $(".js-header-newsletter-open", this.$container)),
                        (this.$searchInput = $(".search-form__input")),
                        $(".header-search-form", this.$container).find("a, button, input").attr("tabindex", "-1"),
                        $(".js-header-search-trigger", this.$container).on(
                            "click" + this.namespace,
                            function (a) {
                                a.preventDefault(),
                                    $("body").toggleClass("show-search"),
                                    $(".header-search-form", this.$container).find("a, button, input").removeAttr("tabindex"),
                                    $(".header-search-form .search-form__input", this.$container).focus();
                            }.bind(this)
                        ),
                        $('.search-form__input[data-live-search="true"]', this.$container).on(
                            "change" + this.namespace + " keyup" + this.namespace + " paste" + this.namespace,
                            function (a) {
                                this.functions.fetchSearchResults.bind(this)(a);
                            }.bind(this)
                        ),
                        $(this.$container).on("click" + this.namespace, ".js-mobile-menu-icon", this.functions.mobileMenuOpen.bind(this)),
                        $(this.$container).on("click" + this.namespace, ".js-close-mobile-menu", this.functions.mobileMenuClose.bind(this)),
                        (this.$mobileDropdownContainer = $(".mobile-nav-column-inner", a)),
                        $(this.$container).on("click" + this.namespace, ".js-mobile-dropdown-trigger", this.functions.mobileMenuDropdownOpen.bind(this)),
                        $(this.$container).on("click" + this.namespace, ".js-mobile-dropdown-return", this.functions.mobileMenuDropdownClose.bind(this)),
                        this.$newsletterSignupButton.length > 0 &&
                            ($(this.$container).on("click" + this.namespace, ".js-header-newsletter-open", function () {
                                $.colorbox({ transition: "none", html: $(".header-newsletter-wrapper").html(), onOpen: theme.colorboxFadeTransOnOpen, onComplete: theme.colorboxFadeTransOnComplete });
                            }),
                            $(".header-newsletter-wrapper .form-success, .header-newsletter-wrapper .errors").length &&
                                $.colorbox({ transition: "fade", html: $(".header-newsletter-wrapper").html(), onOpen: theme.colorboxFadeTransOnOpen, onComplete: theme.colorboxFadeTransOnComplete })),
                        $(".main-nav__has-dropdown > a, .main-nav__child-has-dropdown > a", this.$container).attr("aria-haspopup", "true").attr("aria-expanded", "false"),
                        this.$container.on("mouseenter" + this.namespace + " mouseleave" + this.namespace, ".main-nav__has-dropdown, .main-nav__child-has-dropdown", function (a) {
                            "mouseenter" == a.type
                                ? ($(this).children("[aria-expanded]").attr("aria-expanded", !0), $(this).addClass("show-dropdown"))
                                : ($(this).children("[aria-expanded]").attr("aria-expanded", !1), $(this).removeClass("show-dropdown"));
                        }),
                        this.$container.on("keydown" + this.namespace, ".main-nav__has-dropdown > .main-nav__link", function (a) {
                            40 == a.which && (a.preventDefault(), $(a.target).trigger("mouseenter")), (38 == a.which || 27 == a.which) && (a.preventDefault(), $(a.target).trigger("mouseleave"));
                        }),
                        this.$container.on("keydown" + this.namespace, ".main-nav__child-has-dropdown > .main-nav__child-link", function (a) {
                            (39 == a.which || 40 == a.which) && (a.preventDefault(), $(a.target).trigger("mouseenter")), (37 == a.which || 38 == a.which || 27 == a.which) && (a.preventDefault(), $(a.target).trigger("mouseleave"));
                        }),
                        this.$container.on("keydown" + this.namespace, ".main-nav__sub-child-link", function (a) {
                            27 == a.which && (a.preventDefault(), $(a.target).trigger("mouseleave"));
                        }),
                        $(this.$container).on(
                            "touchstart" + this.namespace + " touchend" + this.namespace + " click" + this.namespace,
                            ".main-nav__has-dropdown > .main-nav__link, .main-nav__child-has-dropdown > .main-nav__child-link",
                            function (a) {
                                if (!$(this).next(".dropdown-chevron").is(":visible")) {
                                    if ("touchstart" == a.type) $(this).data("touchstartedAt", a.timeStamp);
                                    else if ("touchend" == a.type) {
                                        if (a.timeStamp - $(this).data("touchstartedAt") < 1e3)
                                            return (
                                                $(this).data("touchOpenTriggeredAt", a.timeStamp),
                                                $(this).parent().hasClass("show-dropdown")
                                                    ? $(this).trigger("mouseleave")
                                                    : ($(".main-nav .show-dropdown").removeClass("show-dropdown").children("a").attr("aria-expanded", !1), $(this).trigger("mouseenter")),
                                                !1
                                            );
                                    } else if ("click" == a.type && $(this).data("touchOpenTriggeredAt") && a.timeStamp - $(this).data("touchOpenTriggeredAt") < 1e3) return !1;
                                }
                            }
                        ),
                        this.functions.assessMenuPositions.bind(this)(),
                        $(window).on("debouncedresize" + this.namespace, this.functions.assessMenuPositions.bind(this)),
                        $(".disclosure", this.$container).each(function () {
                            $(this).data("disclosure", new theme.Disclosure($(this)));
                        });
                }),
                    (this.functions = {
                        assessMenuPositions: function () {
                            var a = $(window).width();
                            $(".main-nav__dropdown", this.$container).each(function () {
                                var b = $(this).outerWidth(),
                                    d = parseInt($(this).css("margin-left")) || 0,
                                    c = a - 20 - ($(this).offset().left - d + b);
                                $(this).css("margin-left", c < 0 ? c : ""), $(this).toggleClass("main-nav__dropdown--expand-left", $(this).offset().left + 2 * b > a);
                            });
                        },
                        fetchSearchResults: function (g) {
                            var b = $(g.target),
                                c = b.val(),
                                f = !1;
                            if ((this.$searchInput.data("live-search-meta") && (f = !0), c != b.data("previous-terms"))) {
                                if ((b.data("previous-terms", c), c.length > 0)) {
                                    this.searchXhr && this.searchXhr.abort(), this.$searchBar.addClass("search-bar--show-results search-bar--loading").removeClass("search-bar--has-results");
                                    var d,
                                        e,
                                        a = b.closest("form"),
                                        h = a.attr("action") + (a.attr("action").indexOf("?") > -1 ? "&" : "?") + a.serialize();
                                    theme.shopifyFeatures.predictiveSearch
                                        ? ((d = theme.routes.search_url + "/suggest.json"),
                                          (e = {
                                              q: a.find('input[name="q"]').val(),
                                              resources: {
                                                  type: a.find('input[name="type"]').val(),
                                                  limit: 12,
                                                  options: { unavailable_products: "last", fields: f ? "title,product_type,variants.title,vendor,tag,variants.sku" : "title,product_type,variants.title,vendor" },
                                              },
                                          }))
                                        : ((d = a.attr("action") + "?" + a.serialize() + "&view=data"), (e = null)),
                                        (this.searchXhr = $.ajax({ url: d, data: e, dataType: "json", success: this.functions.buildSearchResults.bind(this, h) }).always(
                                            function () {
                                                (this.searchXhr = null), this.$searchBar.removeClass("search-bar--loading");
                                            }.bind(this)
                                        ));
                                } else this.searchXhr && this.searchXhr.abort(), this.$searchBar.removeClass("search-bar--loading search-bar--has-results");
                            }
                        },
                        buildSearchResults: function (i, a) {
                            this.$searchBar.addClass("search-bar--has-results");
                            var e = $(".search-bar__results-list", this.$searchBar).empty();
                            if (
                                (a.resources.results.products && a.resources.results.products.length > 0) ||
                                (a.resources.results.pages && a.resources.results.pages.length > 0) ||
                                (a.resources.results.articles && a.resources.results.articles.length > 0)
                            ) {
                                var h = $('<div class="search-bar__results-products">'),
                                    d = $('<div class="search-bar__results-pages">');
                                if (a.resources.results.products)
                                    for (var c = 0; c < a.resources.results.products.length; c++) {
                                        var b = a.resources.results.products[c],
                                            f = $('<a class="mini-product">').attr("href", b.url),
                                            j = $('<div class="mini-product__image-container">').appendTo(f);
                                        b.image && $('<img class="mini-product__image" alt="" role="presentation"/>').attr("src", slate.Image.getSizedImageUrl(b.image, "100x100_crop_center")).appendTo(j);
                                        var g = $('<div class="mini-product__details">').appendTo(f);
                                        if (
                                            ($('<div class="mini-product__title">').html(b.title).appendTo(g),
                                            this.$searchInput.data("live-search-vendor") && $('<div class="mini-product__vendor small-text">').html(b.vendor).appendTo(g),
                                            this.$searchInput.data("live-search-price"))
                                        ) {
                                            var k = $('<div class="mini-product__price">').html(theme.Shopify.formatMoney(b.price_min, theme.moneyFormat)).appendTo(g);
                                            parseFloat(b.compare_at_price_min) > parseFloat(b.price_min) && k.addClass("mini-product__price--on-sale");
                                        }
                                        f.appendTo(h);
                                    }
                                if (a.resources.results.pages)
                                    for (var c = 0; c < a.resources.results.pages.length; c++) {
                                        var b = a.resources.results.pages[c];
                                        $('<a class="search-bar__results-pages__link">').attr("href", b.url).html(b.title).appendTo(d);
                                    }
                                if (a.resources.results.articles)
                                    for (var c = 0; c < a.resources.results.articles.length; c++) {
                                        var b = a.resources.results.articles[c];
                                        $('<a class="search-bar__results-pages__link">').attr("href", b.url).html(b.title).appendTo(d);
                                    }
                                e.append(h),
                                    d.children().length && ($('<h6 class="search-bar__results-pages-title small-cap-heading">').html(theme.strings.searchResultsPages).prependTo(d), e.append(d)),
                                    $('<a class="search-bar__results-all-link">').html(theme.strings.searchResultsViewAll).attr("href", i).appendTo(e);
                            } else $("<div>").html(theme.strings.searchResultsNoResults).appendTo(e);
                        },
                        mobileMenuOpen: function (a) {
                            a.preventDefault(),
                                $(document.body).addClass("mobile-menu-prime"),
                                setTimeout(function () {
                                    $(document.body).addClass("mobile-menu-open");
                                }, 10);
                        },
                        mobileMenuClose: function (a) {
                            a.preventDefault(),
                                $(document.body).removeClass("mobile-menu-open"),
                                setTimeout(function () {
                                    $(document.body).removeClass("mobile-menu-prime");
                                }, 500);
                        },
                        mobileMenuDropdownOpen: function (a) {
                            a.preventDefault();
                            var c = $(a.currentTarget).siblings(".main-nav__dropdown");
                            if (c.length) {
                                var b = c.clone().wrap('<div class="mobile-nav-menu-container mobile-dropdown mobile-menu-level-2">').parent();
                                $('<a class="mobile-dropdown__back js-mobile-dropdown-return" href="#">')
                                    .html(['<span class="feather-icon">', theme.icons.arrowLeft, '</span><span class="mobile-dropdown__back-text">', $(a.currentTarget).siblings(".main-nav__link").html(), "</span>"].join(""))
                                    .prependTo(b),
                                    this.$mobileDropdownContainer.append(b),
                                    setTimeout(
                                        function () {
                                            this.$mobileDropdownContainer.addClass("show-mobile-menu-level-2");
                                        }.bind(this),
                                        10
                                    );
                            } else if ((c = $(a.currentTarget).siblings(".main-nav__sub-dropdown")).length) {
                                var b = c.clone().wrap('<div class="mobile-nav-menu-container mobile-dropdown mobile-menu-level-3">').parent();
                                $('<a class="mobile-dropdown__back js-mobile-dropdown-return" href="#">')
                                    .html(['<span class="feather-icon">', theme.icons.arrowLeft, '</span><span class="mobile-dropdown__back-text">', $(a.currentTarget).siblings(".main-nav__child-link").html(), "</span>"].join(""))
                                    .prependTo(b),
                                    this.$mobileDropdownContainer.append(b),
                                    setTimeout(
                                        function () {
                                            this.$mobileDropdownContainer.addClass("show-mobile-menu-level-3");
                                        }.bind(this),
                                        10
                                    );
                            }
                        },
                        mobileMenuDropdownClose: function (a) {
                            if ((a.preventDefault(), this.$mobileDropdownContainer.hasClass("show-mobile-menu-level-3"))) {
                                this.$mobileDropdownContainer.removeClass("show-mobile-menu-level-3");
                                var b = this.$mobileDropdownContainer.find(".mobile-menu-level-3");
                                setTimeout(function () {
                                    b.remove();
                                }, this.mobileMenuTransitionTime);
                            } else if (this.$mobileDropdownContainer.hasClass("show-mobile-menu-level-2")) {
                                this.$mobileDropdownContainer.removeClass("show-mobile-menu-level-2");
                                var b = this.$mobileDropdownContainer.find(".mobile-menu-level-2");
                                setTimeout(function () {
                                    b.remove();
                                }, this.mobileMenuTransitionTime);
                            }
                        },
                    }),
                    (this.onSectionUnload = function () {
                        this.$container.off(this.namespace),
                            $(".js-header-search-trigger", this.$container).off(this.namespace),
                            $(".search-form__input", this.$container).off(this.namespace),
                            $(document).off(this.namespace),
                            $(window).off(this.namespace),
                            this.$searchBar.off(this.namespace),
                            $(".disclosure", this.$container).each(function () {
                                $(this).data("disclosure").unload();
                            });
                    });
            })()),
            (theme.Footer = new (function () {
                (this.onSectionLoad = function (a) {
                    (this.$container = $(a)),
                        (this.namespace = theme.namespaceFromSection(a)),
                        $(".disclosure", this.$container).each(function () {
                            $(this).data("disclosure", new theme.Disclosure($(this)));
                        });
                }),
                    (this.onSectionUnload = function () {
                        $(".disclosure", this.$container).each(function () {
                            $(this).data("disclosure").unload();
                        });
                    });
            })()),
            (theme.Banner = new (function () {
                (this.onSectionLoad = function (a) {
                    (this.$container = $(a)),
                        (this.namespace = theme.namespaceFromSection(a)),
                        (this.$slideshow = $(".slideshow", this.$container)),
                        (this.stackBreakpoint = 840),
                        this.$slideshow
                            .on("init", function () {
                                $(".lazyload--manual", this).removeClass("lazyload--manual").addClass("lazyload");
                            })
                            .slick({
                                autoplay: this.$slideshow.data("autoplay"),
                                fade: "slide" != this.$slideshow.data("transition"),
                                speed: "instant" == this.$slideshow.data("transition") ? 0 : 500,
                                autoplaySpeed: 1e3 * this.$slideshow.data("autoplay-speed"),
                                infinite: !0,
                                useTransform: !0,
                                arrows: !1,
                                dots: this.$slideshow.find(".slide").length > 1,
                                pauseOnHover: "instant" != this.$slideshow.data("transition") || this.$slideshow.data("autoplay-speed") > 2,
                            }),
                        (this.$companionContent = $(".banner-section__companion-column .overlay__inner", this.$container)),
                        this.$companionContent.children().length > 1 && (this.functions.assessCompanionCarousel.bind(this)(), $(window).on("debouncedresize" + this.namespace, this.functions.assessCompanionCarousel.bind(this)));
                }),
                    (this.functions = {
                        assessCompanionCarousel: function () {
                            $(window).width() < this.stackBreakpoint
                                ? this.$companionContent.hasClass("slick-slider") ||
                                  (this.$companionContent.addClass("slick-slider").children().addClass("slide"),
                                  this.$companionContent.parent().addClass("overlay--with-slider"),
                                  this.$companionContent.slick({ autoplay: !0, fade: !1, infinite: !0, useTransform: !0, arrows: !1, dots: !1, autoplaySpeed: 7e3 }))
                                : this.$companionContent.hasClass("slick-slider") &&
                                  (this.$companionContent.slick("unslick"), this.$companionContent.parent().removeClass("overlay--with-slider"), this.$companionContent.removeClass("slick-slider").children().removeClass("slide"));
                        },
                    }),
                    (this.onBlockSelect = function (a) {
                        $(a).closest(".slick-slider").slick("slickGoTo", $(a).data("slick-index")).slick("slickPause");
                    }),
                    (this.onBlockDeselect = function (a) {
                        $(a).closest(".slick-slider").slick("slickPlay");
                    }),
                    (this.onSectionUnload = function () {
                        this.$slideshow.slick("unslick").off("init"), this.$companionContent.hasClass("slick-slider") && this.$companionContent.slick("unslick"), $(window).off(this.namespace);
                    });
            })()),
            (theme.FeaturedCollection = new (function () {
                (this.onSectionLoad = function (a) {
                    (this.$container = $(a)),
                        (this.namespace = theme.namespaceFromSection(a)),
                        (this.$carousel = $("[data-grid-carousel]", this.$container)),
                        this.$carousel.length &&
                            (this.$carousel.addClass("swiper-container").children(".grid").addClass("swiper-wrapper").removeClass("grid").children().addClass("swiper-slide").removeClass("grid__item"),
                            (this.carouselSwiper = new Swiper(this.$carousel, {
                                init: !1,
                                freeMode: !1,
                                slidesPerView: this.$carousel.data("grid-carousel-columns"),
                                autoHeight: !1,
                                grabCursor: !0,
                                effect: "slide",
                                centeredSlides: !1,
                                spaceBetween: 14,
                                navigation: { nextEl: $(".carousel-next", this.$container), prevEl: $(".carousel-prev", this.$container) },
                                autoplay: !1,
                                breakpoints: { 768: { slidesPerView: 2 }, 560: { spaceBetween: 12, freeMode: !0, slidesPerView: 2 } },
                            })),
                            this.carouselSwiper.once("init", function (a) {
                                this.$el.find(".swiper-slide-duplicate .lazyloading").addClass("lazyload");
                            }),
                            this.carouselSwiper.init()),
                        theme.initProductTitleAlignmentWatcher(this.$container, this.namespace);
                }),
                    (this.onSectionUnload = function () {
                        $(window).off(this.namespace), this.$carousel.length && this.carouselSwiper.destroy();
                    });
            })()),
            (theme.MiniCollectionList = new (function () {
                (this.onSectionLoad = function (b) {
                    (this.$container = $(b)), (this.namespace = theme.namespaceFromSection(b)), (this.$slideshow = $(".swiper-container", this.$container));
                    var a = 4;
                    $(".sidebar").length && (a = 3),
                        this.$slideshow.find(".swiper-slide", this.$container).length > 0 &&
                            (this.mySwiper = new Swiper(this.$slideshow, {
                                freeMode: !0,
                                slidesPerView: a,
                                grabCursor: !0,
                                spaceBetween: 14,
                                navigation: {
                                    nextEl: '[data-section-id="'.concat(this.$container.attr("data-section-id"), '"] .mini-collection-slider-next'),
                                    prevEl: '[data-section-id="'.concat(this.$container.attr("data-section-id"), '"] .mini-collection-slider-prev'),
                                },
                                breakpoints: { 1090: { slidesPerView: a - 1 }, 720: { slidesPerView: a - 2 }, 520: { slidesPerView: 1, spaceBetween: 12 } },
                            }));
                }),
                    (this.onBlockSelect = function (a) {
                        this.mySwiper && this.mySwiper.slideTo($(a).index(), 1e3);
                    }),
                    (this.onSectionUnload = function () {
                        this.mySwiper && this.mySwiper.destroy();
                    });
            })()),
            (theme.LogoList = new (function () {
                (this.onSectionLoad = function (b) {
                    (this.$container = $(b)), (this.namespace = theme.namespaceFromSection(b)), (this.$slideshow = $(".swiper-container", this.$container));
                    var a,
                        c = 768;
                    $("body").hasClass("page-has-sidebar") && (c = 1e3),
                        this.$slideshow.data("items-per-row"),
                        this.$slideshow.find(".swiper-slide").length > 0 &&
                            (this.mySwiper = new Swiper(this.$slideshow, {
                                freeMode: !0,
                                slidesPerView: this.$slideshow.data("items-per-row"),
                                grabCursor: !0,
                                spaceBetween: 14,
                                navigation: {
                                    nextEl: '[data-section-id="'.concat(this.$container.attr("data-section-id"), '"] .logo-list-slider-next'),
                                    prevEl: '[data-section-id="'.concat(this.$container.attr("data-section-id"), '"] .logo-list-slider-prev'),
                                },
                                breakpoints: (_defineProperty((a = {}), c, { slidesPerView: 3 }), _defineProperty(a, 560, { slidesPerView: 3, spaceBetween: 12 }), a),
                            }));
                }),
                    (this.onBlockSelect = function (a) {
                        this.mySwiper && this.mySwiper.slideTo($(a).index(), 1e3);
                    }),
                    (this.onSectionUnload = function () {
                        this.mySwiper && this.mySwiper.destroy();
                    });
            })()),
            (theme.BackgroundVideo = new (function () {
                (this.onSectionLoad = function (a) {
                    theme.VideoManager.onSectionLoad(a);
                }),
                    (this.onSectionUnload = function () {
                        theme.VideoManager.onSectionUnload(container);
                    });
            })()),
            (theme.Gallery = new (function () {
                (this.onSectionLoad = function (a) {
                    if (((this.$container = $(a)), (this.namespace = theme.namespaceFromSection(a)), (this.$carouselGallery = $(".gallery--mobile-carousel", a)), this.$carouselGallery.length)) {
                        var b = function () {
                            var b = !!this.carouselSwiper,
                                a = "flex" === this.$carouselGallery.css("display");
                            if ((a || $(".lazyload--manual", this.$carouselGallery).removeClass("lazyload--manual").addClass("lazyload"), b && !a)) {
                                this.carouselSwiper.destroy(),
                                    (this.carouselSwiper = null),
                                    this.$carouselGallery.removeClass("swiper-container").find(".swiper-slide").removeClass("swiper-slide").addClass("gallery__item").appendTo(this.$carouselGallery),
                                    this.$carouselGallery.find(".swiper-wrapper").remove();
                                var d = 3,
                                    e = null;
                                this.$carouselGallery.find(".gallery__item").each(
                                    function (a, b) {
                                        a % d == 0 &&
                                            (e = $('<div class="gallery__row">')
                                                .addClass(Math.floor(a / 3) % 2 == 0 ? "gallery__row--odd" : "gallery__row--even")
                                                .appendTo(this.$carouselGallery)),
                                            $(b).appendTo(e);
                                    }.bind(this)
                                );
                            } else if (!b && a) {
                                this.$carouselGallery.find(".gallery__item").appendTo(this.$carouselGallery), this.$carouselGallery.find(".gallery__row").remove(), this.$carouselGallery.addClass("swiper-container");
                                var c = $('<div class="swiper-wrapper">').appendTo(this.$carouselGallery);
                                this.$carouselGallery.find(".gallery__item").removeClass("gallery__item").addClass("swiper-slide").appendTo(c),
                                    (this.carouselSwiper = new Swiper(this.$carouselGallery, {
                                        init: !1,
                                        freeMode: !1,
                                        slidesPerView: 1,
                                        autoHeight: !1,
                                        grabCursor: !0,
                                        effect: "slide",
                                        centeredSlides: !1,
                                        spaceBetween: 14,
                                        autoplay: !1,
                                    })),
                                    this.carouselSwiper.once("init", function (a) {
                                        this.$el.find(".swiper-slide-duplicate .lazyloading").addClass("lazyload");
                                    }),
                                    this.carouselSwiper.init();
                            }
                        };
                        b.call(this), $(window).on("debouncedresize" + this.namespace, b.bind(this));
                    }
                }),
                    (this.onSectionUnload = function (a) {
                        $(window).off(this.namespace), this.carouselSwiper && this.carouselSwiper.destroy();
                    }),
                    (this.onBlockSelect = function (a) {}),
                    (this.onBlockDeselect = function (a) {});
            })()),
            (theme.Collection = new (function () {
                (this.onSectionLoad = function (a) {
                    theme.initProductTitleAlignmentWatcher($(a), ".collectionTemplate");
                }),
                    (this.onSectionUnload = function () {});
            })()),
            (theme.Cart = new (function () {
                var a = { termsCheckbox: "#terms" };
                (this.onSectionLoad = function (b) {
                    if (
                        ((this.$container = $(b)),
                        (this.namespace = ".cartTemplate"),
                        this.$container.on("click" + this.namespace, ".js-shipping-calculator-trigger", function () {
                            var b = $(this),
                                a = b.parents(".shipping-calculator-container");
                            a.toggleClass("calculator-open"),
                                a.hasClass("calculator-open")
                                    ? (b.children().html(theme.strings.cart_shipping_calculator_hide_calculator), a.children(".shipping-calculator").slideDown(250))
                                    : (b.children().html(theme.strings.cart_shipping_calculator_title), a.children(".shipping-calculator").slideUp(250));
                        }),
                        this.$container.on("click" + this.namespace, ".js-cart-notes-trigger", function () {
                            var b = $(this),
                                a = b.parent(".cart-notes-container");
                            a.toggleClass("notes-open"),
                                a.hasClass("notes-open")
                                    ? (b.children().html(theme.strings.cart_general_hide_note), a.children(".cart-notes").slideDown(250))
                                    : (b.children().html(theme.strings.cart_general_show_note), a.children(".cart-notes").slideUp(250));
                        }),
                        $(a.termsCheckbox, b).length > 0 &&
                            $(document).on("click" + this.namespace, '[name="checkout"], a[href="/checkout"]', function () {
                                if (0 == $(a.termsCheckbox + ":checked").length) return alert(theme.strings.cartTermsNotChecked), !1;
                            }),
                        this.$container.data("ajax-update"))
                    ) {
                        var c = this.functions.updateCart.bind(this);
                        this.$container.on("keyup" + this.namespace + " change" + this.namespace, ".quantity-adjuster__input", function () {
                            if ((!$(this).data("initial-value") || $(this).data("initial-value") != $(this).val()) && 0 != $(this).val().length && "0" != $(this).val()) {
                                var a = $(this).attr("id");
                                c({ line: $(this).data("line"), quantity: $(this).val() }, function () {
                                    console.log("Focussing on: #" + a), $("#" + a).focus();
                                }),
                                    $(this).data("previousValue", $(this).val());
                            }
                        }),
                            this.$container.on("click" + this.namespace, ".quantity-adjuster__button--down, .quantity-adjuster__button--up", function (b) {
                                var a = $(this).closest(".quantity-adjuster").find(".quantity-adjuster__input");
                                return $(this).hasClass("quantity-adjuster__button--down") ? a.val(parseInt(a.val()) - 1).trigger("change") : a.val(parseInt(a.val()) + 1).trigger("change"), !1;
                            });
                    }
                    theme.cartNoteMonitor.load($('.cart-notes [name="note"]', this.$container)), theme.initProductTitleAlignmentWatcher(this.$container, this.namespace);
                }),
                    (this.functions = {
                        updateCart: function (a, b) {
                            var _ = this;
                            _.cartXhr && _.cartXhr.abort(),
                                _.cartRefreshXhr && _.cartRefreshXhr.abort(),
                                (_.cartXhr = $.ajax({
                                    type: "POST",
                                    url: theme.routes.cart_change_url + ".js",
                                    data: a,
                                    dataType: "json",
                                    success: function (a) {
                                        _.cartRefreshXhr && _.cartRefreshXhr.abort(),
                                            (_.cartRefreshXhr = $.ajax({
                                                type: "GET",
                                                url: theme.routes.cart_url + "?view=ajax",
                                                success: function (e) {
                                                    var c = [".cart-items", ".cart-subtotal-and-discounts"],
                                                        d = $("<div>" + e + "</div>");
                                                    d.find(".fade-in").removeClass("fade-in");
                                                    for (var a = 0; a < c.length; a++) $('[data-section-type="cart"] ' + c[a]).html(d.find(c[a]).html());
                                                    b();
                                                },
                                                error: function (a) {
                                                    "abort" != a.statusText && (console.log("Error refreshing page"), console.log(a));
                                                },
                                                complete: function () {
                                                    _.cartRefreshXhr = null;
                                                },
                                            }));
                                    },
                                    error: function (a) {
                                        console.log("Error processing update"), console.log(a);
                                    },
                                }));
                        },
                    }),
                    (this.onSectionUnload = function () {
                        $(window).off(this.namespace), $(document).off(this.namespace), this.$container.off(this.namespace), theme.cartNoteMonitor.unload($('.cart-notes [name="note"]', this.$container));
                    });
            })()),
            (theme.customerAddresses = void (
                (d = $("#AddressNewForm")).length &&
                (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", { hideElement: "AddressProvinceContainerNew" }),
                $(".address-country-option").each(function () {
                    var a = $(this).data("form-id");
                    new Shopify.CountryProvinceSelector("AddressCountry_" + a, "AddressProvince_" + a, { hideElement: "AddressProvinceContainer_" + a });
                }),
                $(".address-new-toggle").on("click", function () {
                    d.toggleClass("hide");
                }),
                $(".address-edit-toggle").on("click", function () {
                    var a = $(this).data("form-id");
                    $("#EditAddress_" + a).toggleClass("hide");
                }),
                $(".address-delete").on("click", function () {
                    var a = $(this),
                        b = a.data("form-id"),
                        c = a.data("confirm-message");
                    confirm(c || "Are you sure you wish to delete this address?") && Shopify.postLink(theme.routes.account_addresses_url + "/" + b, { parameters: { _method: "delete" } });
                }))
            )),
            (theme.customerLogin = (function () {
                var a = { recoverPasswordForm: "#RecoverPassword", hideRecoverPasswordLink: "#HideRecoverPasswordLink" };
                function b(a) {
                    a.preventDefault(), c();
                }
                function c() {
                    $("#RecoverPasswordForm").toggleClass("hide"), $("#CustomerLoginForm").toggleClass("hide");
                }
                $(a.recoverPasswordForm).length &&
                    ("#recover" === window.location.hash && c(), $(".reset-password-success").length && $("#ResetSuccess").removeClass("hide"), $(a.recoverPasswordForm).on("click", b), $(a.hideRecoverPasswordLink).on("click", b));
            })()),
            (theme.namespaceFromSection = function (a) {
                return [".", $(a).data("section-type"), $(a).data("section-id")].join("");
            }),
            (theme.openPageContentInLightbox = function (a) {
                $.get(a, function (a) {
                    var b = $("#MainContent", $.parseHTML("<div>" + a + "</div>"));
                    $.colorbox({
                        transition: "fade",
                        html: '<div class="lightbox-content">' + b.html() + "</div>",
                        onOpen: theme.colorboxFadeTransOnOpen,
                        onComplete: function () {
                            theme.colorboxFadeTransOnComplete(), $("#cboxContent .input-wrapper input").trigger("inputstateEmpty");
                        },
                    });
                });
            }),
            (theme.styleVariantSelectors = function (a, b) {
                a.each(function () {
                    if (void 0 !== $(this).data("listed")) {
                        $(this).clickyBoxes();
                        var a = $(this).closest(".selector-wrapper").find(".variant-option-title");
                        if (
                            (a.length &&
                                (a.data("default-content", a.html()),
                                $(this)
                                    .siblings(".clickyboxes")
                                    .on("change", function () {
                                        a.data("default-content", $(this).find("a.active").data("value"));
                                    })
                                    .on("mouseenter", "a", function () {
                                        a.html($(this).data("value"));
                                    })
                                    .on("mouseleave", "a", function () {
                                        a.html(a.data("default-content"));
                                    })),
                            1 == b.options.length)
                        )
                            for (var c = 0; c < b.variants.length; c++) {
                                var d = b.variants[c];
                                d.available ||
                                    $(this)
                                        .siblings(".clickyboxes")
                                        .find("a")
                                        .filter(function () {
                                            return $(this).data("value") == d.option1;
                                        })
                                        .addClass("unavailable");
                            }
                    } else {
                        var e = {};
                        theme.select2.init($(this), e);
                    }
                });
            }),
            (theme.select2 = {
                init: function (d, a) {
                    var b = { minimumResultsForSearch: 1 / 0 },
                        c = { minimumResultsForSearch: 1 / 0, templateResult: theme.select2.swatchSelect2OptionTemplate, templateSelection: theme.select2.swatchSelect2OptionTemplate };
                    void 0 !== a && ((b = $.extend(b, a)), (c = $.extend(c, a))),
                        d.each(function () {
                            $(this).select2($(this).data("colour-swatch") ? c : b);
                        });
                },
                swatchSelect2OptionTemplate: function (a) {
                    return a.id
                        ? $(
                              [
                                  '<div class="swatch-option">',
                                  '<span class="swatch-option__nugget bg-',
                                  removeDiacritics(a.id)
                                      .toLowerCase()
                                      .replace(/'/g, "")
                                      .replace(/[^a-z0-9]+/g, "-")
                                      .replace(/-+/g, "-")
                                      .replace(/-*$/, ""),
                                  '"></span>',
                                  '<span class="swatch-option__label">',
                                  a.text,
                                  "</span>",
                                  "</div>",
                              ].join("")
                          )
                        : $(['<div class="swatch-option swatch-option--all">', '<span class="swatch-option__label">', a.text, "</span>", "</div>"].join(""));
                },
            }),
            (theme.colorboxFadeTransOnOpen = function () {
                $("#colorbox").addClass("colorbox--hide");
            }),
            (theme.colorboxFadeTransOnComplete = function () {
                setTimeout(function () {
                    $("#colorbox").addClass("colorbox--enable-trans"),
                        setTimeout(function () {
                            $("#colorbox").removeClass("colorbox--hide"),
                                setTimeout(function () {
                                    $("#colorbox").removeClass("colorbox--enable-trans");
                                }, 300);
                        }, 20);
                }, 10);
            }),
            (theme.productGallerySlideshowTabFix = function (a, b) {
                $(a[b])
                    .find("a, input, button, select, iframe, video, model-viewer, [tabindex]")
                    .each(function () {
                        void 0 !== $(this).data("theme-slideshow-original-tabindex")
                            ? !1 === $(this).data("theme-slideshow-original-tabindex")
                                ? $(this).removeAttr("tabindex")
                                : $(this).attr("tabindex", $(this).data("theme-slideshow-original-tabindex"))
                            : $(this).removeAttr("tabindex");
                    }),
                    $(a)
                        .not(a[b])
                        .find("a, input, button, select, iframe, video, model-viewer, [tabindex]")
                        .each(function () {
                            void 0 === $(this).data("theme-slideshow-original-tabindex") &&
                                ($(this).data("theme-slideshow-original-tabindex", void 0 !== $(this).attr("tabindex") && $(this).attr("tabindex")), $(this).attr("tabindex", "-1"));
                        });
            });
        try {
            theme.shopifyFeatures = JSON.parse(document.documentElement.querySelector("#shopify-features").textContent);
        } catch (h) {
            theme.shopifyFeatures = {};
        }
        $(document).ready(function () {
            slate.a11y.pageLinkFocus($(window.location.hash)),
                $(".in-page-link").on("click", function (a) {
                    slate.a11y.pageLinkFocus($(a.currentTarget.hash));
                }),
                $(document).on("keyup.themeTabCheck", function (a) {
                    9 === a.keyCode && ($("body").addClass("tab-used"), $(document).off("keyup.themeTabCheck"));
                }),
                slate.rte.wrapTable({ $tables: $(".rte table"), tableWrapperClass: "rte__table-wrapper" }),
                slate.rte.wrapIframe({ $iframes: $('.rte iframe[src*="youtube.com/embed"],.rte iframe[src*="player.vimeo"]'), iframeWrapperClass: "rte__video-wrapper" }),
                document.querySelector(".footer-blocks").addEventListener("click", function (c) {
                    if (c.target.matches(".js-footer-block-toggle")) {
                        var a = c.target,
                            b = a.parentNode.nextElementSibling;
                        a.classList.toggle("is-active"), a.classList.contains("is-active") ? (b.style.height = "".concat(b.scrollHeight, "px")) : (b.style.height = null);
                    }
                }),
                slate.cart.cookiesEnabled() && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies")),
                $(document).on("change", ".quantity-proxy", function () {
                    var a = $(this).val(),
                        b = $(this).siblings('[name="quantity"]');
                    "10+" == a
                        ? (b.val("10").closest(".quantity-wrapper").addClass("hide-proxy"),
                          setTimeout(function () {
                              b.select().focus();
                          }, 10))
                        : b.val(a);
                });
        }),
            (theme.initProductTitleAlignmentWatcher = function (b, c) {
                var a = $(".product-grid", b);
                a.length && (theme.alignProductImageTitles.bind(a)(), $(window).on("debouncedresize" + c, theme.alignProductImageTitles.bind(a)));
            }),
            (theme.alignProductImageTitles = function () {
                $(this).each(function () {
                    var a = 0;
                    $(".product-block__primary-image", this).each(function () {
                        var b = $(this).height();
                        b > a && (a = b);
                    }),
                        $(".product-block__image", this).css("min-height", a);
                });
            }),
            $(".section-search").length && theme.initProductTitleAlignmentWatcher($(".section-search"), "main-search"),
            theme.Sections.init(),
            theme.Sections.register("sidebar", theme.Sidebar, { deferredLoad: !1 }),
            theme.Sections.register("product", theme.Product, { deferredLoad: !1 }),
            theme.Sections.register("header", theme.Header, { deferredLoad: !1 }),
            theme.Sections.register("footer", theme.Footer),
            theme.Sections.register("banner", theme.Banner),
            theme.Sections.register("featured-collection", theme.FeaturedCollection),
            theme.Sections.register("mini-collection-list", theme.MiniCollectionList),
            theme.Sections.register("logo-list", theme.LogoList),
            theme.Sections.register("background-video", theme.VideoManager, { deferredLoadViewportExcess: 800 }),
            theme.Sections.register("gallery", theme.Gallery),
            theme.Sections.register("collection", theme.Collection, { deferredLoad: !1 }),
            theme.Sections.register("cart", theme.Cart, { deferredLoad: !1 }),
            $(function ($) {
                a.sections.length
                    ? a.sections.forEach(function (a) {
                          try {
                              theme.Sections.register(a.name, a.section);
                          } catch (b) {
                              console.error("Unable to register section ".concat(a.name, "."), b);
                          }
                      })
                    : console.warn("Barry: No common sections have been registered.");
            });
    })(theme.jQuery);
